// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:16:17.183Z
// Property: Chugach South (ID: 6767906449167187)
// Collections: 13 amenities, 2 floorplans (live), 13 photos, 81 POIs, 4 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167187",
  "property_external_id": "1101849",
  "property_zillow_url": "https://www.zillow.com/b/chugach-south-anchorage-ak-5XnDJG/",
  "property_apartments_url": "https://www.apartments.com/chugach-south-anchorage-ak/bp3b4h8/",
  "property_google_business_url": "https://www.google.com/maps/place/Chugach+South/data=!4m2!3m1!1s0x0:0x175b327a1d766b0c?sa=X&ved=2ahUKEwif4OG68YOTAxUKj2oFHR64GmQQ_BJ6BAgTEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47754697591",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "chugach-south",
  "property_name": "Chugach South",
  "property_website_url": "https://www.chugachsouth.com",
  "property_domain": "https://www.chugachsouth.com",
  "property_address": "9600 Morningside Loop",
  "property_full_address": "9600 Morningside Loop, Anchorage, AK 99515",
  "property_address_1": "9600 Morningside Loop",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99515",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Bayshore / Klatt",
  "property_address_latitude": "61.13369489999999",
  "property_address_longitude": "-149.8629631",
  "property_email": "chugachsouth@weidner.com",
  "property_phone": "(907) 308-5109",
  "property_call_tracking_phone": "907-308-5109",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Relaxed South Anchorage living starts here.</strong> Chugach South offers comfortable one and two-bedroom <a href=\"/floor-plans\">floor plans</a> with grounded home details like fireplaces, large closets, and patios or balconies—plus everyday conveniences that keep routines simple. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see it for yourself.</p>",
  "property_long_description": "<p><strong>Relaxed South Anchorage living starts at Chugach South.</strong> Set in Bayshore/Klatt, this community pairs everyday practicality with a location close to Dimond-area shopping, dining, and services. Choose from comfortable one and two-bedroom <a href=\"/floor-plans\">floor plans</a> with the details that make home feel grounded: a wood-burning fireplace, dishwasher, dining area, large closets, and a patio or balcony, with vaulted ceilings available in select homes.</p><p>Beyond your front door, <a href=\"/amenities\">community conveniences</a> help keep the routine simple, including laundry facilities, internal mailboxes, keyed building entry, on-call security and courtesy patrol, responsive management, and online payments and service requests. When you want to get out, Old Seward Highway and Dimond Transit Center help connect you across Anchorage, while nearby Kincaid Park, Campbell Creek Trail, and access points to the Anchorage Coastal Wildlife Refuge bring trails, coastal scenery, and open-air Alaska moments within easy reach. Explore the area, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Chugach South for yourself.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
  "property_featured_image_media": {
    "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
    "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
    "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
    "width": 1448,
    "height": 1086
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "40",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": "61",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.5",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://chugachsouth.securecafe.com/onlineleasing/chugach-south-0/floorplans.aspx",
  "property_resident_portal_url": "https://chugachsouth.securecafenet.com/residentservices/chugach-south-0/userlogin",
  "property_apply_now_url": "https://chugachsouth.securecafe.com/onlineleasing/chugach-south-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb494-fbd9-7737-bc73-3575a79217da.webp",
  "property_primary_logo_media": {
    "alt_text": "Chugach South Apartment Homes logo",
    "public_id": "019fb494-fbd9-7737-bc73-3575a79217da",
    "storage_key": "property/6767906449167187/019fb494-fbd9-7737-bc73-3575a79217da.webp",
    "width": 131,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb495-3c72-7696-8524-4cc946f992f6.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fb495-3c72-7696-8524-4cc946f992f6",
    "storage_key": "property/6767906449167187/019fb495-3c72-7696-8524-4cc946f992f6.webp",
    "width": 131,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb495-3121-72f8-a4d0-f9de98675254.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fb495-3121-72f8-a4d0-f9de98675254",
    "storage_key": "property/6767906449167187/019fb495-3121-72f8-a4d0-f9de98675254.webp",
    "width": 131,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#a67c3d",
  "property_secondary_color": "#6b4e2e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d4c4a0",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "725 - 725",
  "property_sqft_min": "725",
  "property_sqft_max": "725",
  "property_price_range": "1785 - 1785",
  "property_price_min": "1785",
  "property_price_max": "1785",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/ChugachSouthApartments",
  "property_instagram_url": "https://www.instagram.com/chugachsouthapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJN_0mcsSZyFYRDGt2HXoyWxc",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Chugach South Apartments",
  "property_home_romance_title": "Life in Bayshore, Anchorage",
  "property_home_amenities_blurb": "<p><strong>Everyday comfort, Anchorage-ready.</strong> Chugach South pairs practical apartment features with cozy extras, including wood-burning fireplaces, private patios or balconies, dishwashers, dining areas, and generous closet space. Select homes add vaulted ceilings for an airy finish, while keyed building entry, internal mailboxes, laundry facilities, smoke-free living, online payments, and responsive management help keep the day moving smoothly.</p>",
  "property_home_floorplans_blurb": "<p>Discover one- and two-bedroom apartments with layouts made for Anchorage living. Every floor plan is designed with you in mind, featuring oversized closets for storage, inviting living spaces, and a wood-burning fireplace for cozy winter nights. Choose a layout that fits your lifestyle, whether you're working from home, entertaining friends, or simply relaxing. Plus, with a private balcony or patio in each home, it's always easy to take in Alaska's fresh air. Select floor plans feature vaulted ceilings or beautiful views for an extra touch of luxury.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the comfort in every frame.</strong> Explore bright interiors with clean finishes, practical flow, and wide windows that bring Anchorage views inside. Look for standout details like a wood-burning fireplace, open breakfast bar, defined dining area, generous closet space, and a patio or balcony—then view the full gallery to picture Chugach South in sharper detail.</p>",
  "property_home_neighborhood_blurb": "<p>In Anchorage's Bayshore area, Chugach South puts you close to everything that makes city life convenient yet connected to the great outdoors. Employers like the University of Alaska, Alaska Pacific University, and Alaska Regional Hospital are all within easy reach, plus public transit at Dimond Transit Center makes getting around stress-free. Take a stroll or plan a picnic at a nearby park, shop at Dimond Center, or try new restaurants close to home. Year-round outdoor adventures like fishing, hiking, skiing, and even dog sledding are all part of life when you live at Chugach South.</p>",
  "property_home_reviews_blurb": "<p><strong>Service that shows up in the reviews.</strong> Chugach South residents point to responsive maintenance, clear communication, and thoughtful follow-through—from quick troubleshooting to careful repairs. Reviews also mention friendly help from Augustine Salas, attentive management from Mark and the team, plus everyday essentials like snow removal, cleaning, and trash service handled with consistency. Read what residents are saying, then see the community for yourself.</p>",
  "property_neighborhood_blurb": "<p>Experience the best of Anchorage's Bayshore at Chugach South Apartments. Dive into a neighborhood full of great shopping, plenty of restaurants, outdoor parks, and an easy connection to Old Seward Highway. Dimond Medical Clinic, Walmart, and Dimond Center are all just a short drive away. Find both city energy and the peace of nearby parks right outside your door. Take public transit at Dimond Transit Center or explore Alaska's natural beauty with hiking, fishing, skiing, and more. Employers such as Alaska Regional Hospital, the University of Alaska, and Alaska Pacific University are within easy reach, making commutes to work and school convenient.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Chugach South, enjoy a blend of in-home comfort and community conveniences. Each apartment features a cozy fireplace, a private balcony or patio for your daily breath of fresh air, and oversized closets for all your essentials. Community perks like climate-controlled hallways, multiple laundry rooms, and indoor mailboxes make your routine easier. Select homes also offer vaulted ceilings and beautiful views. Here, Anchorage living feels both modern and warm.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Chugach South home?</strong><br>Start your application online for relaxed South Anchorage living with comfortable one and two-bedroom floor plans, practical in-home features, and everyday conveniences designed to keep life simple.</p>",
  "property_contactus_blurb": "<p>Interested in making Chugach South your next home? Our leasing team in Anchorage is here to answer your questions, provide details, and help guide you through your options. Reach out today to take the next step toward comfortable living.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Chugach South?</strong> Start here for quick answers about leasing, apartment features, community conveniences, and everyday living in South Anchorage. If you need more details or want help finding the right next step, our leasing team is happy to help through <a href=\"/contact-us\">contact us</a> or a tour.</p>",
  "property_floorplans_blurb": "<p>Explore bright, open layouts with oversized closets, fireplaces to keep you cozy in winter, and plenty of storage for your outdoor gear. Chugach South's floor plans feature private patios or balconies for fresh air and relaxation, and select homes offer vaulted ceilings or stunning views. Spacious rooms and dining areas give you flexibility for work, play, or unwinding at the end of the day - all in a location convenient to urban Anchorage.</p>",
  "property_gallery_blurb": "<p>Take a closer look at your future home in Anchorage, AK. The Chugach South photo gallery invites you to picture life in modern apartments with beautiful kitchens, warm living spaces, and large windows that let in plenty of natural light. Preview community amenities and imagine quiet evenings by your in-home fireplace or fresh mornings on your private balcony. Browse our gallery to get inspired for your Anchorage move.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Chugach South on the map.</strong> See available one and two-bedroom apartments in Bayshore/Klatt, then zoom out to nearby shopping, dining, services, transit connections, and outdoor escapes across South Anchorage.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, perches, and everyday pet routines.</strong> At Chugach South, you can settle into a pet-friendly Anchorage apartment that keeps care simple, from large closets for food, litter, toys, and winter gear to a patio or balcony for a quick breath of fresh air. Smoke-free living, keyed building entry, and responsive management add ease between walks, feedings, and vet visits, while South Anchorage Sports Park’s off-leash dog area gives you a nearby option when your dog needs more room to roam. Review the policy details, explore <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/contact-us\">contact the leasing team</a> with pet questions.</p>",
  "property_referafriend_blurb": "<p><strong>Love relaxed South Anchorage living?</strong> Share Chugach South with a friend and invite them to see the comfortable one and two-bedroom homes, practical everyday conveniences, and easy access to shopping, dining, services, and Anchorage connections that make life here feel grounded.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access makes the routine simple.</strong><br>Log in to pay rent online, submit service requests, and manage your Chugach South account with ease. With responsive management and everyday conveniences built around practical South Anchorage living, home stays grounded and connected.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, everyday confidence.</strong> At Chugach South, residents consistently call out the people who keep things running—especially responsive maintenance support, clear communication, and helpful follow-through when service requests come up.</p><p>Reviews highlight team members like Augustine Salas for being “very friendly and more than helpful,” responding quickly, troubleshooting issues, and completing repairs with care. Residents also note prompt snow removal, regular cleaning, consistent trash service, and attentive management from Mark and the team. Read the reviews below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Chugach South for yourself.</p>",
  "property_created_at": "1771538110269",
  "property_scheduletour_blurb": "<p>Choose how you visit Chugach South. Whether it's a personal guided walk-through with our leasing team or a virtual tour from your own space, you can discover layouts, amenities, and Anchorage's local charm at your own pace. From cozy interiors to community spaces, your new home is waiting to be explored.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>The Chugach South leasing team will follow up soon. In the meantime, picture relaxed South Anchorage living with comfortable one and two-bedroom homes, practical everyday conveniences, and easy access to shopping, dining, services, and open-air Alaska moments.</p>",
  "property_virtualtours_blurb": "<p>Step inside Chugach South's welcoming community in Anchorage, AK from wherever you are. This virtual tour lets you experience the atmosphere, view the layouts, and imagine how your days could unfold in these comfortable spaces. See the details that set this community apart - from spacious rooms to inviting common areas - and picture how you'll make Chugach South home, all on your own schedule.</p>",
  "property_copyright": "2026 All Rights Reserved. Chugach South",
  "property_seo_title_home": "Modern Living | Chugach South Apartments | Anchorage, AK",
  "property_seo_description_home": "Discover pet-friendly apartments near Dimond Medical Clinic and Walmart. Find your new home at Chugach South in Anchorage, AK.",
  "property_seo_title_floorplans": "Floor Plans | Chugach South Apartments | Anchorage, AK",
  "property_seo_description_floorplans": "Find your ideal one- or two-bedroom apartment at Chugach South: cozy fireplaces, extra storage, and private balconies in Anchorage, AK.",
  "property_seo_title_amenities": "Amenities | Chugach South Apartments | Anchorage, AK",
  "property_seo_description_amenities": "Experience wood-burning fireplaces, oversized closets, and on-site laundry at Chugach South Apartments in Anchorage, AK.",
  "property_seo_title_gallery": "Photo Gallery | Chugach South Apartments | Anchorage, AK",
  "property_seo_description_gallery": "Browse photos of welcoming apartments and community spaces. See Chugach South in Anchorage, AK before you visit.",
  "property_seo_title_virtualtours": "Virtual Tour | Chugach South Apartments | Anchorage, AK",
  "property_seo_description_virtualtours": "Explore your future home at Chugach South Apartments in Anchorage, AK virtually and picture everyday life from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Chugach South Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Chugach South, Anchorage! Explore our map for one and two-bedroom apartments with premium amenities. Your new life awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Chugach South Apartments | Anchorage, AK",
  "property_seo_description_neighborhood": "Live near Dimond Medical Clinic, Dimond Center, parks, and dining in Anchorage, AK at Chugach South Apartments.",
  "property_seo_title_contact": "Contact Chugach South Apartments | Anchorage, AK",
  "property_seo_description_contact": "Connect with our team at Chugach South Apartments. Learn more or schedule a visit in Anchorage, AK.",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Find answers to your questions about living at Chugach South in Anchorage. Learn about our one & two-bedroom plans, amenities, and responsive management today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Discover comfort at Chugach South, Anchorage! Spacious designs, modern amenities, and secure living await. Check out our residents' stories!",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Discover comfort at Chugach South in Anchorage, AK! Spacious 1 & 2 bedroom apartments with great amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Chugach South",
  "property_seo_description_residentaccess": "Simplify your living experience at Chugach South! Log in to access your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Chugach South",
  "property_seo_description_referafriend": "Refer a friend to Chugach South in Anchorage, AK! Great friends create vibrant communities—share the joy of living in a space you love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chugach South Apartments | Anchorage, AK",
  "property_seo_description_scheduletour": "Tour Chugach South Apartments your way. Explore floor plans, atmospheres, and Anchorage living in person or virtually.",
  "property_seo_title_privacy": "Privacy Policy | Chugach South",
  "property_seo_description_privacy": "Safeguarding your personal information is our priority at Chugach South. Read our privacy policy to learn about how we protect your data in Anchorage, AK.",
  "property_seo_title_accessibility": "Website Accessibility | Chugach South",
  "property_seo_description_accessibility": "At Chugach South in Anchorage, AK, we prioritize digital inclusion, ensuring a seamless living experience through our accessibility commitment.",
  "property_seo_title_sitemap": "Sitemap | Chugach South",
  "property_seo_description_sitemap": "Unearth the hidden gems of Chugach South in Anchorage, AK. Navigate our sitemap for easy access to amenities, floor plans, and more!",
  "property_seo_title_thankyou": "Thank You | Chugach South",
  "property_seo_description_thankyou": "Thank you for reaching out to Chugach South! Our team will connect soon to help you discover your perfect Anchorage home. Your journey starts here!",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791843628363",
  "amenities": [
    {
      "id": "ec_84d98f098acfcb2845dcffec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "87456118",
      "title": "Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b68b6fe6b4d00b91d462bb1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "120692095",
      "title": "Keyed Entry Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_112fd078adfb3e5df74d65f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "120692096",
      "title": "Responsive Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_916985f8ab55281dd411b9c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "120692097",
      "title": "Online Payments and Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68c8443dec5783849ff12be1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "120692098",
      "title": "Internal Mailboxes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3a73f4658a7dce3b0b48b3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "122094504",
      "title": "On-Call Security and Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c29e1b191420c4e3628d6b6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "124799786",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_20eab3ded7052f631073700c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "87456123",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2484c3bdfcb8a4f68a90d25d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "87456125",
      "title": "Wood Fireplaces",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-4dd1-726b-97a7-6ecc06c60251.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a lit fireplace and large window.",
        "public_id": "019d021e-4dd1-726b-97a7-6ecc06c60251",
        "storage_key": "property/6767906449167187/019d021e-4dd1-726b-97a7-6ecc06c60251.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Chugach South Apartments - Living Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_153aa3454bc3a783f735e87e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "87456128",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d9a35-3224-75ae-a447-d8733c3c2f70.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a long horizontal window and a closet.",
        "public_id": "019d9a35-3224-75ae-a447-d8733c3c2f70",
        "storage_key": "property/6767906449167187/019d9a35-3224-75ae-a447-d8733c3c2f70.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Chugach South Apartments - Bedroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ab68082a62b7e0cd471266b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "87456130",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "Juliet",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_807222b0b1c24ffbc83ad494",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "87456127",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a55bb6de99f151bc6a03737",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "yardi",
      "external_id": "87456132",
      "title": "Dining Area",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_8f9c2b0fa5cf2cb9eca17d39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space, featuring a warm fireplace and a comfortable sofa, perfect for unwinding after a long day. Enjoy the natural light and tranquil views from the large window.",
      "link": "false",
      "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach_South_Favorites (1).jpg"
    },
    {
      "id": "ec_2957d6b4b0cdfc227579ae27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/01a037a2-97ad-761b-b9c3-c80df1a4150b.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, blue countertops, double sink, dishwasher, and oven.",
        "public_id": "01a037a2-97ad-761b-b9c3-c80df1a4150b",
        "storage_key": "property/6767906449167187/01a037a2-97ad-761b-b9c3-c80df1a4150b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, a double sink, dishwasher, and a stove with an overhead vent. The blue countertops add a pop of color.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, blue countertops, double sink, dishwasher, and oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach_South_Favorites (8).jpg"
    },
    {
      "id": "ec_20b4a276a8aa4bf18e3ab5a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019e0641-39ac-7248-a2f7-a40288869827.webp",
      "image_media": {
        "alt_text": "Clean bedroom with a large bed and large windows overlooking trees.",
        "public_id": "019e0641-39ac-7248-a2f7-a40288869827",
        "storage_key": "property/6767906449167187/019e0641-39ac-7248-a2f7-a40288869827.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Step into this serene bedroom, featuring a plush queen-size bed and ample natural light streaming in through large windows.",
      "link": "false",
      "alt_text": "Clean bedroom with a large bed and large windows overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach_South_Favorites (3).jpg"
    },
    {
      "id": "ec_a6249af7142d691c58b710b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-3725-756b-a6eb-03a04064dc52.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink.",
        "public_id": "019d021e-3725-756b-a6eb-03a04064dc52",
        "storage_key": "property/6767906449167187/019d021e-3725-756b-a6eb-03a04064dc52.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub with a shower curtain, a toilet, and a vanity with a sink and ample counter space.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (4).jpg"
    },
    {
      "id": "ec_23156e32c4b618e219600d42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-438b-767c-a7ac-ff0288b73506.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large window.",
        "public_id": "019d021e-438b-767c-a7ac-ff0288b73506",
        "storage_key": "property/6767906449167187/019d021e-438b-767c-a7ac-ff0288b73506.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace and a large window with a view of the trees.",
      "link": "false",
      "alt_text": "Living room with fireplace and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (5).jpg"
    },
    {
      "id": "ec_43c2b2ca93dc91b152769fb4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-4dd1-726b-97a7-6ecc06c60251.webp",
      "image_media": {
        "alt_text": "Living room with a lit fireplace and large window.",
        "public_id": "019d021e-4dd1-726b-97a7-6ecc06c60251",
        "storage_key": "property/6767906449167187/019d021e-4dd1-726b-97a7-6ecc06c60251.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace with a decorative screen and a large window with blinds. Perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Living room with a lit fireplace and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (6).jpg"
    },
    {
      "id": "ec_bed5a66cc1f7d3ea6cadb269",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-5397-75bb-9652-8f32e509e590.webp",
      "image_media": {
        "alt_text": "Apartment living room with a fireplace and a breakfast bar.",
        "public_id": "019d021e-5397-75bb-9652-8f32e509e590",
        "storage_key": "property/6767906449167187/019d021e-5397-75bb-9652-8f32e509e590.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy apartment living room featuring a fireplace and a convenient breakfast bar, perfect for casual dining and entertaining.",
      "link": "false",
      "alt_text": "Apartment living room with a fireplace and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (7).jpg"
    },
    {
      "id": "ec_341714a8464a11418060c4f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-539b-75fc-a0c4-bbcee1b31df8.webp",
      "image_media": {
        "alt_text": "Kitchen counter with seating and view into kitchen.",
        "public_id": "019d021e-539b-75fc-a0c4-bbcee1b31df8",
        "storage_key": "property/6767906449167187/019d021e-539b-75fc-a0c4-bbcee1b31df8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy casual dining at the kitchen counter with bar stools, overlooking the kitchen area.",
      "link": "false",
      "alt_text": "Kitchen counter with seating and view into kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (9).jpg"
    },
    {
      "id": "ec_43c1f4022eef2621bf1a9b65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-600a-76e8-ac6b-0e6339093c99.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls, gray carpet, and a large closet with mirrored doors.",
        "public_id": "019d021e-600a-76e8-ac6b-0e6339093c99",
        "storage_key": "property/6767906449167187/019d021e-600a-76e8-ac6b-0e6339093c99.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush gray carpeting, neutral beige walls, and ample natural light from a large window. Mirrored closet doors add a sense of openness.",
      "link": "false",
      "alt_text": "Empty bedroom with beige walls, gray carpet, and a large closet with mirrored doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (10).jpg"
    },
    {
      "id": "ec_ff6e734eef1d4ef4cf0b24ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-64fc-77ca-b9e9-b9d2dbac4381.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and window.",
        "public_id": "019d021e-64fc-77ca-b9e9-b9d2dbac4381",
        "storage_key": "property/6767906449167187/019d021e-64fc-77ca-b9e9-b9d2dbac4381.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring mirrored closet doors and a large window offering views of the surrounding trees.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (11).jpg"
    },
    {
      "id": "ec_3b102114f0119b1e70379069",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-6797-7458-ae1e-63c37b22a52f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with covered parking.",
        "public_id": "019d021e-6797-7458-ae1e-63c37b22a52f",
        "storage_key": "property/6767906449167187/019d021e-6797-7458-ae1e-63c37b22a52f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building showcasing its architecture and convenient covered parking spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with covered parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (12).jpg"
    },
    {
      "id": "ec_1985c94530a623685a874af6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-736a-76dd-ba33-36765fe73a23.webp",
      "image_media": {
        "alt_text": "Exterior view of Chugach South apartments with a parking lot and landscaping.",
        "public_id": "019d021e-736a-76dd-ba33-36765fe73a23",
        "storage_key": "property/6767906449167187/019d021e-736a-76dd-ba33-36765fe73a23.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the Chugach South apartment buildings featuring a parking lot and lush green lawn. The property's signage is visible on the building.",
      "link": "false",
      "alt_text": "Exterior view of Chugach South apartments with a parking lot and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (13).jpg"
    },
    {
      "id": "ec_dd04748f5fa90354bff456c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-7821-767c-bf5e-813e87248726.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with parking lot and trees",
        "public_id": "019d021e-7821-767c-bf5e-813e87248726",
        "storage_key": "property/6767906449167187/019d021e-7821-767c-bf5e-813e87248726.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a multi-story apartment building with balconies and a parking lot featuring several vehicles, surrounded by mature trees under a partly cloudy sky.",
      "link": "false",
      "alt_text": "Apartment building exterior with parking lot and trees",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Chugach-South_Favorites (14).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d52165cf-8825-4dba-b62e-247ea3ce8f46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "South Restaurant + Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "11124 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Urban-chic spot offering a combination of New American dining with a bar, coffee cafe & kids' fare.",
      "poi_long_description": "Urban-chic spot offering a combination of New American dining with a bar, coffee cafe & kids' fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-ceab-7579-b018-f70b38677bf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-ceab-7579-b018-f70b38677bf4",
        "storage_key": "property/6767906449167187/019d021e-ceab-7579-b018-f70b38677bf4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.southak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1369574684574852737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-restaurant--coffeehouse",
      "poi_latitude": "61.1199527",
      "poi_longitude": "-149.8678209",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-770-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9HO7JWZyFYRgaZzV-u0ARM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_70586b00-ea7b-4ced-b557-72e27fca9161",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Southside Grill",
      "poi_type": "Restaurants",
      "poi_address": "12870 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Hearty plates of familiar American breakfast & lunch fare served in a down-to-earth atmosphere.",
      "poi_long_description": "Hearty plates of familiar American breakfast & lunch fare served in a down-to-earth atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-5b2d-73fa-9288-fcfcb1a56a82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-5b2d-73fa-9288-fcfcb1a56a82",
        "storage_key": "property/6767906449167187/019fb49a-5b2d-73fa-9288-fcfcb1a56a82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://m.facebook.com/SouthsideGrill907/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9655102880782945313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-grill",
      "poi_latitude": "61.10369099999999",
      "poi_longitude": "-149.8584861",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-297-0597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWQnZYOZyFYRIQzrRurQ_YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a279a46f-b0e9-4c09-9e2e-36df1e543bcf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "China Lights Seafood Buffet",
      "poi_type": "Restaurants",
      "poi_address": "9220 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Asian-run eatery serving familiar dishes like sushi, lo mein and Mongolian beef, plus a buffet.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-5f83-72fe-a3fe-edf9d9dae10a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-5f83-72fe-a3fe-edf9d9dae10a",
        "storage_key": "property/6767906449167187/019fb49a-5f83-72fe-a3fe-edf9d9dae10a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chinalightsak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8575098212151958854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-lights-seafood-buffet",
      "poi_latitude": "61.13694580000001",
      "poi_longitude": "-149.8652704",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-522-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUXAq36ZyFYRRp1nIWTeAHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_e1526df3-d776-4377-b915-1c93e8bee080",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Anchorage Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "148 W 91st Ave, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-58ec-731b-ad90-c971cdee247b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-58ec-731b-ad90-c971cdee247b",
        "storage_key": "property/6767906449167187/019fb49a-58ec-731b-ad90-c971cdee247b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://anchoragebrewing.company/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3599058528757855695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-brewing-company",
      "poi_latitude": "61.1385403",
      "poi_longitude": "-149.8816419",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-677-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMZ6k5SeWyFYRz7VzzKls8jE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_e339f913-496e-4dd7-9f92-06105c4991b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Meraki Grill",
      "poi_type": "Restaurants",
      "poi_address": "12870 Old Seward Hwy Ste 103, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-5b97-72cf-890b-4d5bb491234d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-5b97-72cf-890b-4d5bb491234d",
        "storage_key": "property/6767906449167187/019fb49a-5b97-72cf-890b-4d5bb491234d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://wwe.merakiak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15247654440561029452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meraki-grill",
      "poi_latitude": "61.1037877",
      "poi_longitude": "-149.8585017",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-644-3012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzUuF1BmZyFYRTDGMm-2MmtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2c16fe49-c6c0-4546-88a3-bcccc7d31b6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Southside Bistro",
      "poi_type": "Restaurants",
      "poi_address": "1320 Huffman Park Dr, Anchorage, AK 99515, USA",
      "poi_short_description": "An elevated New American menu & a casual bistro menu are offered at this vibrant eatery & wine bar.",
      "poi_long_description": "An elevated New American menu & a casual bistro menu are offered at this vibrant eatery & wine bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-cef7-73ee-9ab3-ce907630872c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-cef7-73ee-9ab3-ce907630872c",
        "storage_key": "property/6767906449167187/019d021e-cef7-73ee-9ab3-ce907630872c.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://southsidebistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10368335788291789318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-bistro",
      "poi_latitude": "61.1097534",
      "poi_longitude": "-149.8576094",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-348-0088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRTkk5qZyFYRBhIaNXe6448",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_02c9d569-94dd-4b63-8633-eeb855f56e8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Judy's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "11620 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Casual, down-to-earth place dishing out breakfast classics (omelets, waffles, pancakes) plus burgers, melts and hot links.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-58a7-7438-9b6a-45d4cb6ce97a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-58a7-7438-9b6a-45d4cb6ce97a",
        "storage_key": "property/6767906449167187/019fb49a-58a7-7438-9b6a-45d4cb6ce97a.webp",
        "width": 1000,
        "height": 598
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17951988471279037005&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "judys-cafe",
      "poi_latitude": "61.1152111",
      "poi_longitude": "-149.8644239",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-349-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-53a2-7324-b057-85eb1caeac80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-53a2-7324-b057-85eb1caeac80",
        "storage_key": "property/6767906449167187/019d021f-53a2-7324-b057-85eb1caeac80.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJb-8TGJeZyFYRTap-omZGIvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_2cc5e1b8-83c7-488c-b01f-8e86f05ad09e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Harley's Old Thyme Cafe",
      "poi_type": "Restaurants",
      "poi_address": "7550 Old Seward Hwy, Anchorage, AK 99518, USA",
      "poi_short_description": "Family-run eatery for classic breakfasts & down-home fare, including chicken-fried steak & catfish.",
      "poi_long_description": "Family-run eatery for classic breakfasts & down-home fare, including chicken-fried steak & catfish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-5ec0-77a8-a8b5-6a5c0b18e3ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-5ec0-77a8-a8b5-6a5c0b18e3ab",
        "storage_key": "property/6767906449167187/019fb49a-5ec0-77a8-a8b5-6a5c0b18e3ab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://harleysotcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11799786668834197692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harleys-old-thyme-cafe",
      "poi_latitude": "61.1524223",
      "poi_longitude": "-149.8647748",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-349-8878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_n5D36XyFYRvJBAFXVDwaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_bf5d2cf1-6b8b-4fcc-b8df-67b3168c750b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Taco King",
      "poi_type": "Restaurants",
      "poi_address": "1330 Huffman Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "Casual local counter-serve chain dishing up classic Mexican dishes. Delivery is available.",
      "poi_long_description": "Casual local counter-serve chain dishing up classic Mexican dishes. Delivery is available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-5de7-74e0-ac47-0a4245b68cc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-5de7-74e0-ac47-0a4245b68cc1",
        "storage_key": "property/6767906449167187/019fb49a-5de7-74e0-ac47-0a4245b68cc1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tacokingak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13884570630741078338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taco-king",
      "poi_latitude": "61.1081977",
      "poi_longitude": "-149.8574328",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-771-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw3t0ZqZyFYRQrEk0Gznr8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2b68d691-d90d-4097-8c12-03b4ff2d05fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Las Margaritas",
      "poi_type": "Restaurants",
      "poi_address": "541 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Relaxed bar offering a menu of Mexican and Italian dishes, including steaks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-5933-72df-95f3-ec4f25303529.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-5933-72df-95f3-ec4f25303529",
        "storage_key": "property/6767906449167187/019fb49a-5933-72df-95f3-ec4f25303529.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://aklasmargaritas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12814250422676491288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-margaritas",
      "poi_latitude": "61.14521480000001",
      "poi_longitude": "-149.8895944",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-349-4922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVC1YC2YyFYRGAyI2t1c1bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_be1b47ab-c4b9-4d66-b889-ffa06f3be8bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-cfa8-756b-b93e-65cc93f2d9c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-cfa8-756b-b93e-65cc93f2d9c5",
        "storage_key": "property/6767906449167187/019fb497-cfa8-756b-b93e-65cc93f2d9c5.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.8691037",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_b9d4fdc9-55ef-404f-92c5-d8f0dde89687",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-5fe3-7329-8413-8eb3d4e3f7a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-5fe3-7329-8413-8eb3d4e3f7a2",
        "storage_key": "property/6767906449167187/019fb49a-5fe3-7329-8413-8eb3d4e3f7a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dbe-770b-b53f-750904eca875.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dbe-770b-b53f-750904eca875",
        "storage_key": "property/6767906449167187/019d021f-5dbe-770b-b53f-750904eca875.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_90bbaed0-dd3f-498f-ab4c-9ec732eab130",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "The Bridge Company",
      "poi_type": "Restaurants",
      "poi_address": "221 W Ship Creek Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Seafood specialist, set in a raised building over a creek, that offers an all-you-can-eat salad bar.",
      "poi_long_description": "Seafood specialist, set in a raised building over a creek, that offers an all-you-can-eat salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6106-7257-b94e-782e36626bb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6106-7257-b94e-782e36626bb4",
        "storage_key": "property/6767906449167187/019fb49a-6106-7257-b94e-782e36626bb4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thebridge.company/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8162769417458497873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bridge-company",
      "poi_latitude": "61.22341169999999",
      "poi_longitude": "-149.8856961",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-644-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVcqGYi9yFYRUTkJd4n7R3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "catering_service"
    },
    {
      "id": "custom_376b0c52-dd47-4606-8b57-2df9255e0db1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Gwennie's Old Alaska Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4333 Spenard Rd, Anchorage, AK 99517, USA",
      "poi_short_description": "Home cooking & all-day breakfasts in an eatery filled with knickknacks, native art & old photos.",
      "poi_long_description": "Home cooking & all-day breakfasts in an eatery filled with knickknacks, native art & old photos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-66e3-7649-9926-fb66aadc70a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-66e3-7649-9926-fb66aadc70a3",
        "storage_key": "property/6767906449167187/019fb49a-66e3-7649-9926-fb66aadc70a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwenniesoldalaskarestaurant.top/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15781866237967564527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwennies-old-alaska-restaurant",
      "poi_latitude": "61.1818463",
      "poi_longitude": "-149.9327172",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-243-2090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXZvL-OXyFYR737JPrpzBNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_03d60fc7-9113-4a82-a14b-cc14e2962c92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Seoul Casa | Korean Mexican Fusion",
      "poi_type": "Restaurants",
      "poi_address": "601 E Dimond Blvd #6th, Anchorage, AK 99515, USA",
      "poi_short_description": "Colorful tacos and burritos anchor the menu of this restaurant fusing Mexican and Korean cuisines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6291-7645-8f79-d66b2975722e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6291-7645-8f79-d66b2975722e",
        "storage_key": "property/6767906449167187/019fb49a-6291-7645-8f79-d66b2975722e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://m.facebook.com/Seoul-Casa-125858284952679/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12325622233161211331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seoul-casa--korean-mexican-fusion",
      "poi_latitude": "61.14568000000001",
      "poi_longitude": "-149.8692498",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-344-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJcOb6X6ZyFYRwx07-x1oDas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_f92d12c5-8088-42e1-a6b9-b7f6e0fca8a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "8900 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Chain department store selling everything from clothing and housewares to electronics and baby supplies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-ee98-7652-84ee-3d760226dd19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-ee98-7652-84ee-3d760226dd19",
        "storage_key": "property/6767906449167187/019d021e-ee98-7652-84ee-3d760226dd19.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2071-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18227266214841406995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.1402087",
      "poi_longitude": "-149.8698771",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-344-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-581d-7399-9fe2-fc6337384327",
        "storage_key": "property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-ThFGNCZyFYRE9YZ2gxC9Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_368d07af-57c4-4a4b-a5ab-86801a4ac960",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "1501 Huffman Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-e82e-7468-8d1e-97847a9c560c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-e82e-7468-8d1e-97847a9c560c",
        "storage_key": "property/6767906449167187/019d021e-e82e-7468-8d1e-97847a9c560c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/1501-huffman-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13401553972197628122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.10919010000001",
      "poi_longitude": "-149.8538036",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-339-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5401-7702-b6fb-e387c5e3bf14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5401-7702-b6fb-e387c5e3bf14",
        "storage_key": "property/6767906449167187/019d021f-5401-7702-b6fb-e387c5e3bf14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTbHrJqZyFYR2pgQT1Xi-7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_18f5d68a-eaf6-48a5-952e-7f0c9350ddb8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-f30b-74ea-b71f-5a7216b91505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-f30b-74ea-b71f-5a7216b91505",
        "storage_key": "property/6767906449167187/019d021e-f30b-74ea-b71f-5a7216b91505.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/dimond/701/00071?cid=loc_70100071_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328825712428702824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.1360991",
      "poi_longitude": "-149.9192402",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-267-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5401-7702-b6fb-e387c5e3bf14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5401-7702-b6fb-e387c5e3bf14",
        "storage_key": "property/6767906449167187/019d021f-5401-7702-b6fb-e387c5e3bf14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZf8OEiYyFYRaNx_PFldMi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1585e808-735d-401e-bb80-61dff95c728e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "330 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-f0a8-76f8-b7cf-500fbb0fedc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-f0a8-76f8-b7cf-500fbb0fedc1",
        "storage_key": "property/6767906449167187/019d021e-f0a8-76f8-b7cf-500fbb0fedc1.webp",
        "width": 1280,
        "height": 343
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/anchorage-AK-10.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=6073767655837963207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "61.1435365",
      "poi_longitude": "-149.884555",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-349-2335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-581d-7399-9fe2-fc6337384327",
        "storage_key": "property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK_i7Yc2ZyFYRx5N6toBbSlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_8bfca42d-d7a0-4984-84af-75f5d03f0359",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Dimond Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 E Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_long_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-ca1a-737d-85ee-54793f8162bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-ca1a-737d-85ee-54793f8162bf",
        "storage_key": "property/6767906449167187/019fb497-ca1a-737d-85ee-54793f8162bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dimondcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335366531638308692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-center",
      "poi_latitude": "61.14370340000001",
      "poi_longitude": "-149.8692814",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-344-2581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-581d-7399-9fe2-fc6337384327",
        "storage_key": "property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRVC8_E8ksiBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4e7d6c1b-a715-43c8-aff5-40143db2c748",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Goodwill Retail Store and Donation Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8931 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6944-7718-9d5c-c70672bc137a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6944-7718-9d5c-c70672bc137a",
        "storage_key": "property/6767906449167187/019fb49a-6944-7718-9d5c-c70672bc137a.webp",
        "width": 857,
        "height": 1280
      },
      "poi_business_url": "http://www.goodwill-alaska.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13567070004612510630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodwill-retail-store-and-donation-center",
      "poi_latitude": "61.13958350000001",
      "poi_longitude": "-149.8593902",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-344-4660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-581d-7399-9fe2-fc6337384327",
        "storage_key": "property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMy61SciZyFYRpjPJq0nqR7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_fb21d723-7b58-4a8a-bda6-0ed54b22aa37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Glacier Games",
      "poi_type": "Shopping & Retail",
      "poi_address": "9191 Old Seward Hwy Ste 7, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-68e7-7529-bb71-bbefd006932e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-68e7-7529-bb71-bbefd006932e",
        "storage_key": "property/6767906449167187/019fb49a-68e7-7529-bb71-bbefd006932e.webp",
        "width": 1280,
        "height": 597
      },
      "poi_business_url": "https://www.glaciergamesak.com/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=11351167432576094337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-games",
      "poi_latitude": "61.13794679999999",
      "poi_longitude": "-149.8624909",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-720-2307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-581d-7399-9fe2-fc6337384327",
        "storage_key": "property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-8rJoSeZyFYRgVCujKNyh50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_7161cba7-f021-4c1d-b0a8-f328d710bad7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1530 Huffman Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_long_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6acd-753f-bee9-787041b40ce3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6acd-753f-bee9-787041b40ce3",
        "storage_key": "property/6767906449167187/019fb49a-6acd-753f-bee9-787041b40ce3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/1530-huffman-rd/2746611?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8109052636291433564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.1082723",
      "poi_longitude": "-149.8534859",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-345-0438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-57c2-74c8-9241-f73ab1786850.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-57c2-74c8-9241-f73ab1786850",
        "storage_key": "property/6767906449167187/019d021f-57c2-74c8-9241-f73ab1786850.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJm87LP4WZyFYRXIQYu2gkiXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b12e81a7-da3e-4c7a-8447-6556e0161343",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Brown Jug Old Seward South - #212",
      "poi_type": "Shopping & Retail",
      "poi_address": "9200 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Clean storefront stocking beer, wine, spirits, and cigars, plus a growler bar and refills.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6d2b-70a8-aa12-2a746f85f6cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6d2b-70a8-aa12-2a746f85f6cf",
        "storage_key": "property/6767906449167187/019fb49a-6d2b-70a8-aa12-2a746f85f6cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brownjugalaska.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12020675858498575176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brown-jug-old-seward-south---212",
      "poi_latitude": "61.137286",
      "poi_longitude": "-149.8651043",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-344-3404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-581d-7399-9fe2-fc6337384327",
        "storage_key": "property/6767906449167187/019d021f-581d-7399-9fe2-fc6337384327.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmzSwPcWZyFYRSNvrSQEF0qY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_b55b3025-3bae-476f-9d3a-9ae963ac5408",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Bayshore Elementary School",
      "poi_type": "Education",
      "poi_address": "10500 Bayshore Dr, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6d1a-7439-ab41-9e997329e029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6d1a-7439-ab41-9e997329e029",
        "storage_key": "property/6767906449167187/019fb49a-6d1a-7439-ab41-9e997329e029.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.asdk12.org/bayshore",
      "poi_directions_map_url": "https://maps.google.com/?cid=6654801990769328717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayshore-elementary-school",
      "poi_latitude": "61.12513430000001",
      "poi_longitude": "-149.9403282",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-742-5360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnYs6AVqYyFYRTUJe5iabWlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2a69446c-53de-4608-bed9-a47cd1f3a457",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Klatt Elementary School",
      "poi_type": "Education",
      "poi_address": "11900 Puma St, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6cd8-7573-881e-30d7a32cd753.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6cd8-7573-881e-30d7a32cd753",
        "storage_key": "property/6767906449167187/019fb49a-6cd8-7573-881e-30d7a32cd753.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/klatt",
      "poi_directions_map_url": "https://maps.google.com/?cid=10859309943468236137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klatt-elementary-school",
      "poi_latitude": "61.1128518",
      "poi_longitude": "-149.9090871",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-5750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYaQ0WaiZyFYRaZ1KxtsEtJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_08349af6-fb57-49ef-800e-95cff05e8567",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Ocean View Elementary School",
      "poi_type": "Education",
      "poi_address": "11911 Johns Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-6de3-74a4-9dfd-a44afeeb4296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-6de3-74a4-9dfd-a44afeeb4296",
        "storage_key": "property/6767906449167187/019fb49a-6de3-74a4-9dfd-a44afeeb4296.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/oceanview",
      "poi_directions_map_url": "https://maps.google.com/?cid=16367457294580481914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ocean-view-elementary-school",
      "poi_latitude": "61.11287279999999",
      "poi_longitude": "-149.8775294",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-742-5850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqTHNgKKZyFYRen_Y37DjJOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_04342d9c-38a6-40a6-8629-5a96f49fa83c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Mears Middle School",
      "poi_type": "Education",
      "poi_address": "2700 W 100th Ave, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/mears",
      "poi_directions_map_url": "https://maps.google.com/?cid=11455003443888380767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mears-middle-school",
      "poi_latitude": "61.1292672",
      "poi_longitude": "-149.931338",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe-vwR1CYyFYRX9vX5fBY-J4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2979f911-1dde-4241-904a-092aa0e85dc1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "South Anchorage High School",
      "poi_type": "Education",
      "poi_address": "13400 Elmore Rd, Anchorage, AK 99516, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-98f5-7693-80f1-0b81d0531fc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-98f5-7693-80f1-0b81d0531fc6",
        "storage_key": "property/6767906449167187/019fb49a-98f5-7693-80f1-0b81d0531fc6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/south",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674746772741284534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-anchorage-high-school",
      "poi_latitude": "61.10002129999999",
      "poi_longitude": "-149.8099268",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-742-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlUHgbjCayFYRtuL5DVHlPRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c671e021-9c28-4b4b-89bd-c1a765c0dd42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Goldenview Middle School",
      "poi_type": "Education",
      "poi_address": "15800 Golden View Dr, Anchorage, AK 99516, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-70aa-755e-bd12-753c53c24e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-70aa-755e-bd12-753c53c24e12",
        "storage_key": "property/6767906449167187/019fb49a-70aa-755e-bd12-753c53c24e12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/goldenview",
      "poi_directions_map_url": "https://maps.google.com/?cid=939784683771034487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goldenview-middle-school",
      "poi_latitude": "61.0778993",
      "poi_longitude": "-149.7781214",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-348-8626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv9a2UaubyFYRd3uG0TDJCg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_41205ece-06f1-41ad-960e-428c5b529e94",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Rabbit Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "13650 Lake Otis Pkwy, Anchorage, AK 99516, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-730a-73dd-958f-e5ea6a948f10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-730a-73dd-958f-e5ea6a948f10",
        "storage_key": "property/6767906449167187/019fb49a-730a-73dd-958f-e5ea6a948f10.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/rabbitcreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=16708928726736365519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rabbit-creek-elementary-school",
      "poi_latitude": "61.09635040000001",
      "poi_longitude": "-149.8350871",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn7GllyuayFYRz-dwNiYK4uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_854bca28-cd1c-4b6f-b8b9-125b58ab1311",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Huffman Elementary School",
      "poi_type": "Education",
      "poi_address": "12000 Lorraine St, Anchorage, AK 99516, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-762c-7008-9a26-bc364cab04c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-762c-7008-9a26-bc364cab04c2",
        "storage_key": "property/6767906449167187/019fb49a-762c-7008-9a26-bc364cab04c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://huffman.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8698099934492069894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huffman-elementary-school",
      "poi_latitude": "61.1110848",
      "poi_longitude": "-149.8079061",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-742-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpWIMcCKayFYRBpA_UM7btXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3928c595-832b-428a-86f3-00e9d984feab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Bayshore Early Learning Center",
      "poi_type": "Education",
      "poi_address": "3131 Amber Bay Loop, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-729d-7361-9eca-21e8e0bac52e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-729d-7361-9eca-21e8e0bac52e",
        "storage_key": "property/6767906449167187/019fb49a-729d-7361-9eca-21e8e0bac52e.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://bayshore.club/bayshore-early-learning-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6280380093666780868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayshore-early-learning-center",
      "poi_latitude": "61.12407700000001",
      "poi_longitude": "-149.9432213",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-522-4906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAQAAALCZyFYRxGZxmWtkKFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b5ae7152-ce01-48ec-abe1-2dc2e18a7758",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Bright Beginnings Early Learning Center",
      "poi_type": "Education",
      "poi_address": "1000 Sundown Ct, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7630-71d2-b78c-8915253c9436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7630-71d2-b78c-8915253c9436",
        "storage_key": "property/6767906449167187/019fb49a-7630-71d2-b78c-8915253c9436.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5705352212123872555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-beginnings-early-learning-center",
      "poi_latitude": "61.13240930000001",
      "poi_longitude": "-149.8631524",
      "poi_miles_from_property": "0.09",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-344-9435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsYRn-MOZyFYRK-0h0pt7LU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_d6ceedba-ff69-4e16-a3a1-b38ed020fdbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Regal Dimond Center",
      "poi_type": "Entertainment",
      "poi_address": "800 E Dimond Blvd #201, Anchorage, AK 99515, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-0812-7582-a6ab-dac83feec08c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-0812-7582-a6ab-dac83feec08c",
        "storage_key": "property/6767906449167187/019d021f-0812-7582-a6ab-dac83feec08c.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-dimond-center-cinemas-0922?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18078743811721282702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-dimond-center",
      "poi_latitude": "61.14334389999999",
      "poi_longitude": "-149.8680313",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dbe-770b-b53f-750904eca875.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dbe-770b-b53f-750904eca875",
        "storage_key": "property/6767906449167187/019d021f-5dbe-770b-b53f-750904eca875.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRjkTwIraZ5Po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0f818b11-a8d9-40f8-aecc-7f4014357d1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Dave & Buster's Anchorage",
      "poi_type": "Restaurants",
      "poi_address": "800 E Dimond Blvd #240, Anchorage, AK 99515, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-75d2-75cc-935f-4eed5d854cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-75d2-75cc-935f-4eed5d854cfb",
        "storage_key": "property/6767906449167187/019fb49a-75d2-75cc-935f-4eed5d854cfb.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/anchorage",
      "poi_directions_map_url": "https://maps.google.com/?cid=7826167594773483662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-anchorage",
      "poi_latitude": "61.1432124",
      "poi_longitude": "-149.8691315",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-313-1430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-539f-73f2-97fc-a01f5b435073",
        "storage_key": "property/6767906449167187/019d021f-539f-73f2-97fc-a01f5b435073.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_2MCNGZyFYRjpAlb_YhnGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8c6d8d62-f066-4a64-badc-6da6fafea6e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "H2Oasis Indoor Waterpark",
      "poi_type": "Entertainment",
      "poi_address": "1520 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Guests can drift in the lazy river circling the park, speed down slides or bob in the wave pool.",
      "poi_long_description": "Guests can drift in the lazy river circling the park, speed down slides or bob in the wave pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-77a6-709a-aff1-191662d10706.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-77a6-709a-aff1-191662d10706",
        "storage_key": "property/6767906449167187/019fb49a-77a6-709a-aff1-191662d10706.webp",
        "width": 1280,
        "height": 798
      },
      "poi_business_url": "http://www.h2oasiswaterpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17244752553518220645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h2oasis-indoor-waterpark",
      "poi_latitude": "61.12095840000001",
      "poi_longitude": "-149.8537473",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-522-4420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3HMyZSZyFYRZcX2rxSrUe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_659f1b2b-58d8-443c-abf4-cb5ecbf1a6a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-d57d-7213-a870-0e2401b060dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-d57d-7213-a870-0e2401b060dd",
        "storage_key": "property/6767906449167187/019fb497-d57d-7213-a870-0e2401b060dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_aafbec5b-161d-4718-8b69-3df77f293737",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_long_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-3441-76f8-b066-f057e95d4dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-3441-76f8-b066-f057e95d4dd3",
        "storage_key": "property/6767906449167187/019d021f-3441-76f8-b066-f057e95d4dd3.webp",
        "width": 976,
        "height": 662
      },
      "poi_business_url": "http://www.alaskabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929108756512643080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-botanical-garden",
      "poi_latitude": "61.17777439999999",
      "poi_longitude": "-149.7615572",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-770-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wU15deWyFYRCBiYEgBtSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_a80e180c-ab3f-46df-abca-f418141b84c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-154e-7266-a7dc-4acea941d01a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-154e-7266-a7dc-4acea941d01a",
        "storage_key": "property/6767906449167187/019d021f-154e-7266-a7dc-4acea941d01a.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_0be150ec-d09f-447b-8456-73c509e37d79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-d383-7703-ae27-3720142cc597.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-d383-7703-ae27-3720142cc597",
        "storage_key": "property/6767906449167187/019fb497-d383-7703-ae27-3720142cc597.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5e04-700b-a52a-30d2bbac5cdc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5e04-700b-a52a-30d2bbac5cdc",
        "storage_key": "property/6767906449167187/019d021f-5e04-700b-a52a-30d2bbac5cdc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9c1311cd-63ef-40b4-8700-88f067e2083e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-d705-760c-b8a9-98cc0aaa4ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-d705-760c-b8a9-98cc0aaa4ce0",
        "storage_key": "property/6767906449167187/019fb497-d705-760c-b8a9-98cc0aaa4ce0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.9719066",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5e04-700b-a52a-30d2bbac5cdc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5e04-700b-a52a-30d2bbac5cdc",
        "storage_key": "property/6767906449167187/019d021f-5e04-700b-a52a-30d2bbac5cdc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9e272bd1-61ad-49e9-980a-8ddcc2e16a8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-1696-72c2-bb0a-43baf40436a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-1696-72c2-bb0a-43baf40436a8",
        "storage_key": "property/6767906449167187/019d021f-1696-72c2-bb0a-43baf40436a8.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2806dca8-0ba9-4937-ba20-b51a6446ed10",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Campbell Creek Science Center",
      "poi_type": "Entertainment",
      "poi_address": "5600 Science Center Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "Interactive educational center for kids, with science exhibits and nature treks, plus friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7a29-708e-bc65-ef7e918c0545.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7a29-708e-bc65-ef7e918c0545",
        "storage_key": "property/6767906449167187/019fb49a-7a29-708e-bc65-ef7e918c0545.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.blm.gov/learn/interpretive-centers/campbell-creek-science-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2738030936295452035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-creek-science-center",
      "poi_latitude": "61.1641914",
      "poi_longitude": "-149.7769605",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-621-4602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5e04-700b-a52a-30d2bbac5cdc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5e04-700b-a52a-30d2bbac5cdc",
        "storage_key": "property/6767906449167187/019d021f-5e04-700b-a52a-30d2bbac5cdc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxMQgkmXyFYRg63rPaFw_yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_70d16b1e-ab29-4fcf-b485-f210301ad30c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-e212-77f3-a057-880b58b3fd1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-e212-77f3-a057-880b58b3fd1b",
        "storage_key": "property/6767906449167187/019fb497-e212-77f3-a057-880b58b3fd1b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.8221354",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5e05-73a2-b33c-e85aa052f568",
        "storage_key": "property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_914bb6be-08e1-444c-b256-5e84d444bdc6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Providence ExpressCare - Huffman Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1389 Huffman Park Dr Suite 110, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7bf1-739a-b274-113fa18efd79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7bf1-739a-b274-113fa18efd79",
        "storage_key": "property/6767906449167187/019fb49a-7bf1-739a-b274-113fa18efd79.webp",
        "width": 940,
        "height": 528
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/ak/expresscare-huffman?Is=location&y_source=1_MTQ1MjA4MjktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16232698285760051887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-expresscare---huffman-urgent-care",
      "poi_latitude": "61.1106758",
      "poi_longitude": "-149.8555908",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-227-3312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnzOfgxGZyFYRr_rRHBYhRuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_4084f0b5-3513-4b38-bdad-8f7106dc5752",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "First Care Medical Centers, LLC.",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 Huffman Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-2851-755f-b2ef-a1a3c27ea6a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-2851-755f-b2ef-a1a3c27ea6a0",
        "storage_key": "property/6767906449167187/019d021f-2851-755f-b2ef-a1a3c27ea6a0.webp",
        "width": 1280,
        "height": 1161
      },
      "poi_business_url": "http://www.firstcareak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18398045366535381313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-care-medical-centers-llc",
      "poi_latitude": "61.1092051",
      "poi_longitude": "-149.8577509",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-345-1199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuaf4z5qZyFYRQeHcqcj8Uv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3dc1540f-4c4b-400a-b8b2-6556fb266647",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alpine Urgent Care & Sports Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "1310 E Dimond Blvd #1, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7a7c-70a1-a628-bd4b7deb3752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7a7c-70a1-a628-bd4b7deb3752",
        "storage_key": "property/6767906449167187/019fb49a-7a7c-70a1-a628-bd4b7deb3752.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://alpineurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=41279430031882753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alpine-urgent-care--sports-medicine",
      "poi_latitude": "61.14409449999999",
      "poi_longitude": "-149.8583741",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-344-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYdk8dmZyFYRAbqUQ2ynkgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a4062198-39c8-4264-bb56-700e54f9a8c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Carrs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 Huffman Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021e-e82e-7468-8d1e-97847a9c560c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-e82e-7468-8d1e-97847a9c560c",
        "storage_key": "property/6767906449167187/019d021e-e82e-7468-8d1e-97847a9c560c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.carrsqc.com/ak/anchorage/1501-huffman-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13056946922648322474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs-pharmacy",
      "poi_latitude": "61.1094355",
      "poi_longitude": "-149.8538061",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-339-1360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-614e-71d9-b343-e7f0389cbdf4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-614e-71d9-b343-e7f0389cbdf4",
        "storage_key": "property/6767906449167187/019d021f-614e-71d9-b343-e7f0389cbdf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTbHrJqZyFYRqkGVJwyYM7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2a472ea4-bf60-46bf-a2db-bb8b9e1022f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "12405 Brandon St, Anchorage, AK 99515, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7ed2-7039-a180-550023cd96fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7ed2-7039-a180-550023cd96fe",
        "storage_key": "property/6767906449167187/019fb49a-7ed2-7039-a180-550023cd96fe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-12405+brandon+st-anchorage-ak-99515/id=13449",
      "poi_directions_map_url": "https://maps.google.com/?cid=17812693799856520490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1083248",
      "poi_longitude": "-149.855373",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-646-4023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0LqMoWZyFYRKj1AoaJmM_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_eb1a7c2d-98c9-4c0a-b40d-bc25927549ba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7f2e-7735-8814-91b9921502a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7f2e-7735-8814-91b9921502a7",
        "storage_key": "property/6767906449167187/019fb49a-7f2e-7735-8814-91b9921502a7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00071?cid=loc_70100071P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10191980107924744542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "61.13601629999999",
      "poi_longitude": "-149.9193571",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-267-6733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-614e-71d9-b343-e7f0389cbdf4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-614e-71d9-b343-e7f0389cbdf4",
        "storage_key": "property/6767906449167187/019d021f-614e-71d9-b343-e7f0389cbdf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZf8OEiYyFYRXqmzougvcY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_18ae0232-b736-4114-9093-8f444f075333",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Southside Strength and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11901 Industry Way bld A, Anchorage, AK 99515, USA",
      "poi_short_description": "Neighborhood gym with a 24/7 membership option for fitness and bodybuilding enthusiasts and powerlifters alike, boasting barbells and free weights.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7fef-73b9-be1f-afd4c89da05b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7fef-73b9-be1f-afd4c89da05b",
        "storage_key": "property/6767906449167187/019fb49a-7fef-73b9-be1f-afd4c89da05b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.southsidestrengthandfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590136868049384512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-strength-and-fitness",
      "poi_latitude": "61.112775",
      "poi_longitude": "-149.8610551",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-771-9881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVqBo5CZyFYRQPTlGd0nlE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6fc76a76-69c5-4e8a-8a0f-b409e6b3ad40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "The Alaska Club Summit Luxury Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "11001 O'Malley Centre Dr Ste 103, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-7f36-7762-a60e-d3f7b6fecfba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-7f36-7762-a60e-d3f7b6fecfba",
        "storage_key": "property/6767906449167187/019fb49a-7f36-7762-a60e-d3f7b6fecfba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacsummit-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=15577464395890816040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-summit-luxury-gym",
      "poi_latitude": "61.1214708",
      "poi_longitude": "-149.8603816",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-365-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWflpD5WZyFYRKPRdylVFLtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1ccc4956-8eb6-4bae-8ddb-7857e3b13c9f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Burn & Bloom",
      "poi_type": "Health and Wellness",
      "poi_address": "508 W 2nd Ave Ste 109, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-835d-70a9-9da2-1ac477e05d1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-835d-70a9-9da2-1ac477e05d1d",
        "storage_key": "property/6767906449167187/019fb49a-835d-70a9-9da2-1ac477e05d1d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.burnbloom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3236109589624142074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burn--bloom",
      "poi_latitude": "61.2202141",
      "poi_longitude": "-149.8917751",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-720-8478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg9_ZliiWyFYR-jjIr4b46Cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_089924b3-b30a-4478-916a-b29241ec45a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "KFQD Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10349 Bayshore Dr, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-824c-70ee-9950-c663c92ce60b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-824c-70ee-9950-c663c92ce60b",
        "storage_key": "property/6767906449167187/019fb49a-824c-70ee-9950-c663c92ce60b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10209678715889292881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kfqd-park",
      "poi_latitude": "61.12643079999999",
      "poi_longitude": "-149.9388767",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlUk0B1eYyFYRUZZy67IQsI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_1d940891-5e2c-435f-ab89-7ef96516fef9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Pioneer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1501 Old Klatt Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-835f-7589-9ef8-ca0d29c0def9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-835f-7589-9ef8-ca0d29c0def9",
        "storage_key": "property/6767906449167187/019fb49a-835f-7589-9ef8-ca0d29c0def9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15765009880375384167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-park",
      "poi_latitude": "61.1151013",
      "poi_longitude": "-149.9083108",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1MYmKiZyFYRZ1hMqPWQyNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2f15a26d-c7dc-4a0f-8650-daa5210472e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "South Anchorage Sports Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "779 W Klatt Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "Recreational area with baseball fields, a playground, and picnic tables, as well as a merry-go-round.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-83d6-73bc-8e88-a69ab6ee39dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-83d6-73bc-8e88-a69ab6ee39dd",
        "storage_key": "property/6767906449167187/019fb49a-83d6-73bc-8e88-a69ab6ee39dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14784710653396140022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-anchorage-sports-park",
      "poi_latitude": "61.117003",
      "poi_longitude": "-149.8949243",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQOOu6WZyFYR9j-cqgHYLc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0058b35e-ce09-4d79-8408-2ff08cd3b7cc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "South Anchorage Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "799 W Klatt Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "Fenced park for off-leash dogs with separate play areas for small and large breeds, plus a creek.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-871a-745c-9227-a76b6e0f7047.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-871a-745c-9227-a76b6e0f7047",
        "storage_key": "property/6767906449167187/019fb49a-871a-745c-9227-a76b6e0f7047.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8164234676694725355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-anchorage-dog-park",
      "poi_latitude": "61.121482",
      "poi_longitude": "-149.8933943",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-qGX4yZyFYR67JQty4wTXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_01f845cb-c159-49ca-9394-2fc7297012a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Jewel Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4401 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "Lakefront getaway providing a swimming beach, picnic pavilion & children's play equipment.",
      "poi_long_description": "Lakefront getaway providing a swimming beach, picnic pavilion & children's play equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-86fa-727c-b209-0143e26125ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-86fa-727c-b209-0143e26125ca",
        "storage_key": "property/6767906449167187/019fb49a-86fa-727c-b209-0143e26125ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3912813866064468304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jewel-lake-park",
      "poi_latitude": "61.1411207",
      "poi_longitude": "-149.9595208",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-FffG6YyFYRUNn-7nobTTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_72a534e0-5e45-4af2-94ac-1eae245f8540",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Sand Lake Public Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4646 W 80th Ave, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-89a2-738e-8ee3-1869aaf36cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-89a2-738e-8ee3-1869aaf36cfb",
        "storage_key": "property/6767906449167187/019fb49a-89a2-738e-8ee3-1869aaf36cfb.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16968067485313307393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sand-lake-public-access",
      "poi_latitude": "61.1483424",
      "poi_longitude": "-149.9664336",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpddsGQCZyFYRAZP0Knqveus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_21383359-ce06-4664-8eeb-d739c7c4e50a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Kincaid Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_long_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-888e-77aa-b92e-39b23fbfb928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-888e-77aa-b92e-39b23fbfb928",
        "storage_key": "property/6767906449167187/019fb49a-888e-77aa-b92e-39b23fbfb928.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15637430419620688250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-park",
      "poi_latitude": "61.1536409",
      "poi_longitude": "-150.05538",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxF8gvOiyFYRevFgsR1QA9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f8322816-4728-44f2-82d6-96c6fc5364e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Little Campbell Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8801 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-8fef-722b-972a-603603f85fe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-8fef-722b-972a-603603f85fe4",
        "storage_key": "property/6767906449167187/019fb49a-8fef-722b-972a-603603f85fe4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.org/detail/little-campbell-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=16945797376955916151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-campbell-lake",
      "poi_latitude": "61.16344700000001",
      "poi_longitude": "-150.0233833",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ54VPz_CiyFYRdx80ge6QK-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0b410af3-925f-45f3-85ac-4a1f0c4d658f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Jade Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9100 Jade St Park, Anchorage, AK 99502, USA",
      "poi_short_description": "City park featuring a little league field and a soccer field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-8a1d-75dc-9e59-b28368702558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-8a1d-75dc-9e59-b28368702558",
        "storage_key": "property/6767906449167187/019fb49a-8a1d-75dc-9e59-b28368702558.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4768593260680201458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jade-street-park",
      "poi_latitude": "61.1386716",
      "poi_longitude": "-149.9711819",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5zGhSGWYyFYR8kQqNU5yLUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_3b2984c4-f73c-48fa-b066-8c7edc2b063f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Johns Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "145 Bree Ave, Anchorage, AK 99515, USA",
      "poi_short_description": "Green space with picnic benches, swings, slides, trails and a playground, plus a creek.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-8fe7-75ef-bae9-4012715197ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-8fe7-75ef-bae9-4012715197ad",
        "storage_key": "property/6767906449167187/019fb49a-8fe7-75ef-bae9-4012715197ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6217510568905824677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johns-park",
      "poi_latitude": "61.1054164",
      "poi_longitude": "-149.8817567",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5dfc-707e-806a-cf938613b9a2",
        "storage_key": "property/6767906449167187/019d021f-5dfc-707e-806a-cf938613b9a2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgWn0tp-ZyFYRpVnerusISVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_e04902b4-5d5d-4323-87ae-ddae40599683",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-8f2c-760d-8290-31a8db5be3f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-8f2c-760d-8290-31a8db5be3f0",
        "storage_key": "property/6767906449167187/019fb49a-8f2c-760d-8290-31a8db5be3f0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fb49a-9ee3-7177-a417-e93e48a51707",
        "storage_key": "property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_fc3e0a18-2249-4c23-aa18-62317e5f54a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-9059-72e0-be7e-bdfb614a2f41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-9059-72e0-be7e-bdfb614a2f41",
        "storage_key": "property/6767906449167187/019fb49a-9059-72e0-be7e-bdfb614a2f41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_633505e8-8acb-4e48-872a-d94c01bca3d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-e768-743e-9da6-af76158608b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-e768-743e-9da6-af76158608b8",
        "storage_key": "property/6767906449167187/019fb497-e768-743e-9da6-af76158608b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-62a0-73db-a4ea-f864d8a059c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-62a0-73db-a4ea-f864d8a059c4",
        "storage_key": "property/6767906449167187/019d021f-62a0-73db-a4ea-f864d8a059c4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_7c005aa1-f073-42b5-b210-2b5832979642",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-ed42-70cc-9e10-0819beb041d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-ed42-70cc-9e10-0819beb041d8",
        "storage_key": "property/6767906449167187/019fb497-ed42-70cc-9e10-0819beb041d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.22168490000001",
      "poi_longitude": "-149.8904657",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-6269-70ec-b595-e9d696905af8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-6269-70ec-b595-e9d696905af8",
        "storage_key": "property/6767906449167187/019d021f-6269-70ec-b595-e9d696905af8.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_44e21060-f009-4ed7-8412-3a6cd1c1309e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Bill Sheffield Alaska Railroad Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "4980 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-94fd-74d1-a038-a5b4e60f9279.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-94fd-74d1-a038-a5b4e60f9279",
        "storage_key": "property/6767906449167187/019fb49a-94fd-74d1-a038-a5b4e60f9279.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.alaskarailroad.com/real-estate/depot-rentals",
      "poi_directions_map_url": "https://maps.google.com/?cid=17805455315424171249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-sheffield-alaska-railroad-depot",
      "poi_latitude": "61.1745567",
      "poi_longitude": "-149.9804143",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-265-2466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yjDfmujyFYR8dTyo0WvGfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_e295d50f-300e-4217-bd8d-5deb1cc75692",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Lake Hood Seaplane Base",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99530, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-f015-75bf-85d7-3658a76e7a40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-f015-75bf-85d7-3658a76e7a40",
        "storage_key": "property/6767906449167187/019fb497-f015-75bf-85d7-3658a76e7a40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5592799726301707418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hood-seaplane-base",
      "poi_latitude": "61.1816798",
      "poi_longitude": "-149.9745572",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-62a0-73db-a4ea-f864d8a059c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-62a0-73db-a4ea-f864d8a059c4",
        "storage_key": "property/6767906449167187/019d021f-62a0-73db-a4ea-f864d8a059c4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7z6jb029yFYRmnwdGridnU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f325beb4-98d3-45f6-8c0a-ad5b66d5066e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Old Seward & O'Malley Ctr NNE",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=997362727048284765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-seward--omalley-ctr-nne",
      "poi_latitude": "61.120333",
      "poi_longitude": "-149.863556",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fb49a-9ee3-7177-a417-e93e48a51707",
        "storage_key": "property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJl3BC6pWZyFYRXYrtsR1Y1w0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_2c1685f1-b811-4a09-88ba-4af6b10e3767",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "88th Avenue & Old Seward WNW",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5006075900663059631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "88th-avenue--old-seward-wnw",
      "poi_latitude": "61.14120499999999",
      "poi_longitude": "-149.867784",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fb49a-9ee3-7177-a417-e93e48a51707",
        "storage_key": "property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-VKvbtCZyFYRr1SqIYIneUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_643e6fd5-065e-4e65-9112-5a45ef62226c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Abbott & 88th Avenue NNE",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3067710079264241932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abbott--88th-avenue-nne",
      "poi_latitude": "61.14171999999999",
      "poi_longitude": "-149.847276",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fb49a-9ee3-7177-a417-e93e48a51707",
        "storage_key": "property/6767906449167187/019fb49a-9ee3-7177-a417-e93e48a51707.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJzVZkvd6ZyFYRDDluTBCykio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_e4e2cc8c-c542-4aed-a0ad-c8e558ccdfb5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-1fe7-75e9-8975-a68ecc6c88cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-1fe7-75e9-8975-a68ecc6c88cd",
        "storage_key": "property/6767906449167187/019d021f-1fe7-75e9-8975-a68ecc6c88cd.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5e05-73a2-b33c-e85aa052f568",
        "storage_key": "property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_41403f49-2d8c-407b-8625-650760f6855e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-d150-7567-8836-be0e49a41f52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-d150-7567-8836-be0e49a41f52",
        "storage_key": "property/6767906449167187/019fb497-d150-7567-8836-be0e49a41f52.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2176125b-6089-4e31-be90-de17592c7bdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-1e68-734b-826e-f463e96bb10e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-1e68-734b-826e-f463e96bb10e",
        "storage_key": "property/6767906449167187/019d021f-1e68-734b-826e-f463e96bb10e.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.21082899999999",
      "poi_longitude": "-149.8279354",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5e05-73a2-b33c-e85aa052f568",
        "storage_key": "property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2d51fa79-e896-4300-ab84-d44ba929e321",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Joint Base Elmendorf- Richardson",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10471 20th St, Anchorage, AK 99506, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-497e-717c-a791-6257b16a55a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-497e-717c-a791-6257b16a55a6",
        "storage_key": "property/6767906449167187/019d021f-497e-717c-a791-6257b16a55a6.webp",
        "width": 1150,
        "height": 1280
      },
      "poi_business_url": "https://www.jber.jb.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16361889729797625416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-base-elmendorf--richardson",
      "poi_latitude": "61.2464751",
      "poi_longitude": "-149.810681",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-62bb-7219-bbd6-bda413a299fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-62bb-7219-bbd6-bda413a299fe",
        "storage_key": "property/6767906449167187/019d021f-62bb-7219-bbd6-bda413a299fe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28m2RyKVyFYRSBazLgUcEeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_513eaf84-11ea-429e-8bd5-000e6b6a701e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska VA Healthcare System",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-4e20-704b-9ff1-34fcbc194c8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-4e20-704b-9ff1-34fcbc194c8a",
        "storage_key": "property/6767906449167187/019d021f-4e20-704b-9ff1-34fcbc194c8a.webp",
        "width": 1280,
        "height": 550
      },
      "poi_business_url": "http://www.alaska.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3646700986371871179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-va-healthcare-system",
      "poi_latitude": "61.2327171",
      "poi_longitude": "-149.744364",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 907-257-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5e05-73a2-b33c-e85aa052f568",
        "storage_key": "property/6767906449167187/019d021f-5e05-73a2-b33c-e85aa052f568.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9v_0CiUyFYRyxHD3jmvmzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f56791db-bf4f-4c44-8ab2-8d2d362d8f24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-9553-7293-a28f-aca15f1eb402.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-9553-7293-a28f-aca15f1eb402",
        "storage_key": "property/6767906449167187/019fb49a-9553-7293-a28f-aca15f1eb402.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.18400399999999",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5829-7228-9253-3de9d784b8c6",
        "storage_key": "property/6767906449167187/019d021f-5829-7228-9253-3de9d784b8c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_d3b8c175-ad2d-4fdb-a66c-efcc4b6de6a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb497-f330-77b8-a47a-479f461a0ad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb497-f330-77b8-a47a-479f461a0ad3",
        "storage_key": "property/6767906449167187/019fb497-f330-77b8-a47a-479f461a0ad3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.21632990000001",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-62bb-7219-bbd6-bda413a299fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-62bb-7219-bbd6-bda413a299fe",
        "storage_key": "property/6767906449167187/019d021f-62bb-7219-bbd6-bda413a299fe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1f7c3589-2342-42c2-93aa-c1c0911b67a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "custom",
      "poi_name": "Anchorage School District",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019fb49a-9942-740d-9902-f0a4ae410afe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fb49a-9942-740d-9902-f0a4ae410afe",
        "storage_key": "property/6767906449167187/019fb49a-9942-740d-9902-f0a4ae410afe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253021771947721235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-school-district",
      "poi_latitude": "61.1939631",
      "poi_longitude": "-149.7754994",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-5817-747c-8e5e-c71e04a6ec37",
        "storage_key": "property/6767906449167187/019d021f-5817-747c-8e5e-c71e04a6ec37.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3ueb-mWyFYRE0KuNq7DKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_59b1ef0ac11733991bd91cdd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_674d18bbd19d566c07dc917f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bfb6cf2eb0903c5d9b57e90c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_185e6255121422ae3f85df55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_481a84c0a1ae414516744991",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5df10afc-1a7b-4c16-be5c-b21e1c2edf90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "rating": "5.0",
      "name": "Jeff D",
      "text": "Augustine, one of the maintenance folks with Chugach South, is a spot on professional and very helpful.  I had an issue with my smoke detector malfunctioning and even though he was working on another job, he stopped and helped me.  Thank you Augustine, you  were  very friendly and more than helpful!",
      "date": "2025-04-24",
      "title": ""
    },
    {
      "id": "custom_5e3b934f-a5a0-4f6f-9bfd-90714cf27377",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "rating": "5.0",
      "name": "Sarah",
      "text": "Agustin Salas was fantastic!!! Always request his help in any maintenance problem! He deserves 5 stars. He gave this project his all. We still have unresolved hot water problems. Agustin has given so much effort in this project its hard not to give him these stars. The first maintenance guy wouldn't even give anymore than feeling the water then saying its fine. Its hard to recommend to live here because its an arm and a leg to get things fixed or resolved.",
      "date": "2025-04-19",
      "title": ""
    },
    {
      "id": "custom_a01700bd-80d3-4837-b385-d211fa3a5b0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "rating": "5.0",
      "name": "Bara Gregoire",
      "text": "I submitted a maintenance request today as my toilet was not flushing and Chugach South dispatched the best plumber you can find. His name is Augustine Salas. He called me right away to trouble shoot the issue and then showed up at my apartment within the hour. He fixed the problem and replaced needed parts on the toilet. Everything is in working order now.\nGreat communication and professionalism.",
      "date": "2024-12-23",
      "title": ""
    },
    {
      "id": "custom_78400896-c9c3-4a30-8e49-788ccfc5f9b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "rating": "5.0",
      "name": "Sam Sua Jr",
      "text": "My family and I have been happy tenants for over a year and a half. Our experience has been great. Mark has done a great job responding fast to questions and concerns. The cleaning crew has done a phenomenal job every single week. Snow removal has been prompt and amazing and trash is regularly clear every week. I say all that to say Mark is running a great ship here. We are overly satisfied with his work. He had a great 2023 year and we all look forward to this year being great as well. Thank you Mark and team!",
      "date": "2024-01-09",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a03e6f-a5f8-7273-9fcd-192b66950be2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Chugach South Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-anchorage-ak",
      "search_query": "apartments with dishwashers Anchorage AK",
      "category": "Amenity",
      "h1_title": "Discover Apartments with Dishwashers",
      "h2_subtitle": "Looking for apartments with dishwashers in Anchorage, AK? Chugach South offers these conveniences along with other fantastic amenities.",
      "page_copy": "Experience the best of South Anchorage living at Chugach South, where comfort meets convenience. Our one and two-bedroom apartments feature modern amenities such as dishwashers, helping make daily life easier, and allowing you more time to relax by the fireplace or enjoy the view from your private patio or balcony. \n\nLocated in the picturesque Bayshore / Klatt neighborhood, Chugach South ensures a charming and easygoing lifestyle in Anchorage, AK. Apart from in-home conveniences like dishwashers, you can rely on internal mailboxes and on-call security to enhance your residential experience. Plus, with options for online payments and service requests, managing your living needs is a breeze. Schedule a tour today to see why Chugach South is the perfect choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments with Dishwashers in Anchorage",
      "seo_description": "Chugach South offers apartments with dishwashers in Anchorage, AK. Enjoy great amenities and convenient living at its best.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "fireplace-apartments-south-anchorage",
      "search_query": "fireplace apartments South Anchorage",
      "category": "Amenity",
      "h1_title": "Cozy Fireplace Apartments in South Anchorage",
      "h2_subtitle": "Searching for fireplace apartments in South Anchorage? Chugach South provides this comfort plus more.",
      "page_copy": "At Chugach South, we offer a cozy haven in Anchorage with our fireplace-equipped apartments. Ideal for those chilly Alaskan nights, our one and two-bedroom layouts feature these inviting living spaces, enhancing the warmth and comfort of your home. Enjoy the style and practicality of large closets, along with spacious patios or balconies that complement your fireplace's coziness.\n\nNestled in the serene Bayshore / Klatt area, our community provides the perfect South Anchorage setting. Beyond the inviting warmth of a fireplace, Chugach South boasts amenities like on-call security, internal mailboxes, and the convenience of online payments and service requests. Experience the perfect blend of comfort and convenience by scheduling a tour of our fireplace apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fireplace Apartments in South Anchorage",
      "seo_description": "Chugach South offers fireplace apartments in South Anchorage. Embrace comfort with fireplaces, patios, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "large-closets-apartments-bayshore-klatt",
      "search_query": "large closets apartments Bayshore Klatt",
      "category": "Amenity",
      "h1_title": "Spacious Closets in Bayshore Klatt Apartments",
      "h2_subtitle": "Find apartments with large closets in Bayshore Klatt. Chugach South offers the storage space you need for a clutter-free home.",
      "page_copy": "At Chugach South, enjoy the luxury of large closets in every apartment, providing the storage solution necessary for a neat and organized lifestyle. Our one and two-bedroom layouts are crafted to offer generous space while maintaining a cozy, inviting atmosphere. These large closets are perfect for storing seasonal items or keeping your wardrobe tidy.\n\nLocated in the tranquil Bayshore / Klatt neighborhood, our community combines convenience with comfort. Beyond spacious closets, residents enjoy amenities such as fireplaces, patios or balconies, and on-call security. The ease of online payments and service requests streamlines daily tasks, making living at Chugach South both practical and enjoyable. Schedule your tour today to experience the expansive storage options and welcoming environment firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments With Large Closets in Bayshore Klatt",
      "seo_description": "Discover Chugach South apartments in Bayshore Klatt with large closets, fireplaces, and more amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "patio-balcony-apartments-anchorage",
      "search_query": "patio balcony apartments Anchorage",
      "category": "Amenity",
      "h1_title": "Patio & Balcony Apartments in Anchorage",
      "h2_subtitle": "Explore patio and balcony apartments in Anchorage at Chugach South. Enjoy outdoor living with style and convenience.",
      "page_copy": "Welcome to Chugach South, where our patio and balcony apartments in Anchorage provide the perfect blend of outdoor charm and interior comfort. Whether you're savoring the crisp Alaskan air or enjoying a morning coffee, these spaces add a refreshing extension to your living area. Each one and two-bedroom apartment is designed for relaxation and practicality, offering expansive patios or balconies as well as warm fireplaces.\n\nSituated in the serene Bayshore / Klatt community, Chugach South is committed to enhancing your living experience. Complement your outdoor oasis with amenities like large closets, on-call security, and convenient online payments. Discover a new level of comfort and lifestyle by scheduling a tour of our inviting apartment options today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Patio & Balcony Apartments in Anchorage",
      "seo_description": "Enjoy patio and balcony apartments in Anchorage at Chugach South, offering outdoor spaces, fireplaces, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-99515",
      "search_query": "smoke free apartments 99515",
      "category": "Amenity",
      "h1_title": "Smoke-Free Living in 99515 Apartments",
      "h2_subtitle": "Embrace smoke-free living in the 99515 zip code at Chugach South. Enjoy a cleaner, healthier environment.",
      "page_copy": "Chugach South offers a healthier lifestyle with our smoke-free apartments in the 99515 area. Located in South Anchorage, our community boasts features that cater to comfort and convenience. Our thoughtfully designed one and two-bedroom floor plans prioritize a cleaner living environment, providing a refreshing space that is free from smoke.\n\nBeyond our smoke-free policy, Chugach South enhances everyday living with spacious patios or balconies, ample storage options with large closets, and warming fireplaces. Our location in the Bayshore / Klatt neighborhood allows residents to enjoy all these benefits alongside additional amenities like on-call security and the ease of online payments. Experience a cleaner, vibrant lifestyle by scheduling a tour of our smoke-free apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in 99515",
      "seo_description": "Discover smoke-free living at Chugach South in the 99515 zip code. Enjoy clean air and ample amenities in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-south-anchorage",
      "search_query": "1 bedroom apartments south anchorage",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in South Anchorage",
      "h2_subtitle": "Discover comfortable 1 bedroom apartments in South Anchorage at Chugach South. Enjoy a cozy home with great amenities.",
      "page_copy": "Chugach South is the ideal destination for those seeking 1 bedroom apartments in South Anchorage. Our thoughtfully designed spaces offer more than just a place to live; they provide a sanctuary of comfort. Each apartment comes equipped with a fireplace, large closets, and a private patio or balcony, perfect for unwinding after a long day.\n\nResiding in the Bayshore / Klatt neighborhood, you’ll appreciate the peaceful surroundings while enjoying amenities like on-call security and the convenience of online payments. Chugach South provides a seamless blend of style and function, ensuring that your day-to-day living is both simple and enjoyable. Schedule a tour today and see why our 1 bedroom apartments are the perfect fit for your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in South Anchorage",
      "seo_description": "Find cozy 1 bedroom apartments in South Anchorage at Chugach South, featuring fireplaces, patios, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-bayshore-klatt",
      "search_query": "2 bedroom apartments bayshore klatt",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Bayshore Klatt",
      "h2_subtitle": "Explore spacious 2 bedroom apartments in Bayshore Klatt at Chugach South. Perfect for comfort and convenience.",
      "page_copy": "Nestled in the welcoming Bayshore Klatt community, Chugach South offers spacious 2 bedroom apartments designed for comfort and convenience. These residences are tailored for modern living, featuring large closets, cozy fireplaces, and private patios or balconies that let you enjoy the beautiful Anchorage surroundings year-round.\n\nOur community provides additional benefits such as on-call security and internal mailboxes, enhancing your living experience. With the simplicity of online payments and service requests, managing your home life becomes effortless. Discover how our 2 bedroom apartments in Bayshore Klatt at Chugach South can offer you the perfect blend of comfort and functionality. Schedule a tour today to experience it firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Bayshore Klatt",
      "seo_description": "Discover spacious 2 bedroom apartments in Bayshore Klatt at Chugach South, featuring modern amenities for comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-bayshore-elementary-school",
      "search_query": "apartments near Bayshore Elementary School Anchorage",
      "category": "School",
      "h1_title": "Apartments Near Bayshore Elementary School",
      "h2_subtitle": "Find convenient apartments near Bayshore Elementary School at Chugach South. Enjoy a family-friendly community in Anchorage.",
      "page_copy": "Located in the heart of the Bayshore / Klatt area, Chugach South offers ideal apartment living near Bayshore Elementary School. Our community provides the perfect setting for families seeking proximity to quality education. The convenient location not only simplifies the school commute but also places you close to community amenities.\n\nAt Chugach South, you'll find well-designed one and two-bedroom floor plans featuring spacious closets, fireplaces, and private outdoor spaces. With on-call security and easy online payments, our apartments are designed to make life simpler and more secure. Experience the benefits of living near Bayshore Elementary School, where both comfort and convenience meet. Schedule a tour to explore our family-friendly community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bayshore Elementary School",
      "seo_description": "Discover family-friendly apartments near Bayshore Elementary School at Chugach South, offering comfort and convenience in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "rentals-close-to-klatt-elementary-school-ak",
      "search_query": "rentals close to Klatt Elementary School AK",
      "category": "School",
      "h1_title": "Rentals Near Klatt Elementary School AK",
      "h2_subtitle": "Discover rentals close to Klatt Elementary School in AK at Chugach South. Enjoy a convenient and community-oriented lifestyle.",
      "page_copy": "Chugach South offers prime rentals close to Klatt Elementary School in Anchorage, AK. Our property is perfectly situated for families looking to stay near quality schooling options while enjoying the benefits of a well-connected neighborhood. Living so near Klatt Elementary makes school runs hassle-free and manageable.\n\nOur one and two-bedroom apartments are designed with comfortable living in mind, featuring spacious layouts with fireplaces, large closets, and inviting outdoor spaces like patios or balconies. Residents of Chugach South enjoy conveniences like online service requests and a strong sense of security with on-call patrol services. Discover the comfort and ease of living near Klatt Elementary School by scheduling a tour with us today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Klatt Elementary School AK",
      "seo_description": "Find convenient rentals near Klatt Elementary School at Chugach South, offering comfort and community in Anchorage, AK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-ocean-view-elementary-school",
      "search_query": "apartments surrounding Ocean View Elementary School",
      "category": "School",
      "h1_title": "Apartments Surrounding Ocean View Elementary",
      "h2_subtitle": "Explore apartments surrounding Ocean View Elementary School at Chugach South in Anchorage. Ideal for families seeking convenience and comfort.",
      "page_copy": "Chugach South is your destination for apartments surrounding Ocean View Elementary School in Anchorage. Perfectly positioned for families, our community offers quick and easy access to this esteemed educational institution, making daily school commutes stress-free and convenient.\n\nOur spacious one and two-bedroom apartments provide comfortable living with features such as large closets, fireplaces, and the privacy of a patio or balcony. With added benefits like online payments and an on-call security team, Chugach South ensures your peace of mind and convenience. Experience a blend of comfort and functionality in our apartments near Ocean View Elementary School by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ocean View Elementary School",
      "seo_description": "Discover comfortable apartments near Ocean View Elementary School at Chugach South, perfect for family living in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-mears-middle-school-anchorage",
      "search_query": "apartments near Mears Middle School Anchorage Municipality",
      "category": "School",
      "h1_title": "Apartments Near Mears Middle School",
      "h2_subtitle": "Discover apartments near Mears Middle School in Anchorage Municipality at Chugach South. Ideal for families prioritizing education.",
      "page_copy": "Chugach South offers ideal living options with its apartments near Mears Middle School in Anchorage Municipality. Our community is perfectly located to provide easy access for families seeking proximity to this reputable middle school. With a location that streamlines school commutes, you can focus on what truly matters.\n\nOur well-appointed one and two-bedroom apartments come with modern amenities like fireplaces, generous closet spaces, and patios or balconies for outdoor relaxation. Added conveniences like online payments and on-call security ensure a seamless living experience. Dive into a lifestyle that combines comfort and convenience close to Mears Middle School by scheduling a visit to Chugach South today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mears Middle School",
      "seo_description": "Find convenient and comfortable apartments near Mears Middle School in Anchorage Municipality at Chugach South, ideal for family living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "places-to-live-by-south-anchorage-high-school",
      "search_query": "places to live by South Anchorage High School",
      "category": "School",
      "h1_title": "Places to Live by South Anchorage High",
      "h2_subtitle": "Discover ideal places to live by South Anchorage High School at Chugach South. Enjoy the benefits of a prime location and quality amenities.",
      "page_copy": "Located in the heart of South Anchorage, Chugach South is one of the most convenient places to live by South Anchorage High School. Our community provides the perfect blend of accessibility and comfort, making it an excellent choice for families who want to be close to educational opportunities.\n\nOur one and two-bedroom apartments offer features that enhance everyday living, from fireplaces and large closets to patios or balconies that allow you to appreciate the serene surroundings. Additional conveniences such as online service requests and on-call security contribute to a hassle-free lifestyle. Experience relaxed living and proximity to South Anchorage High School by arranging a tour of Chugach South today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Places to Live by South Anchorage High School",
      "seo_description": "Explore comfortable places to live by South Anchorage High School at Chugach South, offering convenience and quality living in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "rentals-near-goldenview-middle-school",
      "search_query": "rentals near Goldenview Middle School",
      "category": "School",
      "h1_title": "Rentals Near Goldenview Middle School",
      "h2_subtitle": "Explore rentals near Goldenview Middle School at Chugach South. Enjoy a blend of convenience and comfort perfect for families.",
      "page_copy": "Chugach South offers the ideal rentals near Goldenview Middle School, located in the scenic Anchorage Municipality. Our community provides families with easy access to reputable education while maintaining a comfortable living environment.\n\nOur well-designed one and two-bedroom units feature charming fireplaces, ample closet space, and balconies or patios for outdoor enjoyment. We also offer conveniences like online payments and on-call security to enhance your living experience. Experience the perfect combination of location and lifestyle by choosing Chugach South as your home base, just a stone's throw from Goldenview Middle School. Schedule a tour to see why our rentals are a top choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Goldenview Middle School",
      "seo_description": "Find rentals near Goldenview Middle School at Chugach South, offering comfort and a prime location in scenic Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-close-to-rabbit-creek-elementary",
      "search_query": "apartments close to Rabbit Creek Elementary School Anchorage",
      "category": "School",
      "h1_title": "Apartments Close to Rabbit Creek Elementary",
      "h2_subtitle": "Find apartments close to Rabbit Creek Elementary School in Anchorage at Chugach South, offering both convenience and comfort.",
      "page_copy": "For families seeking apartments close to Rabbit Creek Elementary School in Anchorage, Chugach South is an ideal choice. Our community is strategically situated, balancing the convenience of nearby educational facilities with the tranquility of a comfortable home.\n\nOffering spacious one and two-bedroom layouts, our apartments are equipped with modern features such as in-unit fireplaces, expansive closets, and inviting patios or balconies. We prioritize ease of living with amenities like online payment options and on-call security. Explore a seamless blend of proximity and lifestyle by scheduling a visit to Chugach South, the perfect place to call home near Rabbit Creek Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Rabbit Creek Elementary",
      "seo_description": "Discover apartments close to Rabbit Creek Elementary School in Anchorage at Chugach South, combining convenience with comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-surrounding-huffman-elementary",
      "search_query": "apartments surrounding Huffman Elementary School",
      "category": "School",
      "h1_title": "Apartments Surrounding Huffman Elementary",
      "h2_subtitle": "Explore apartments surrounding Huffman Elementary School at Chugach South - a perfect choice for families in Anchorage seeking convenience and comfort.",
      "page_copy": "At Chugach South, discover a community that's ideal for families searching for apartments surrounding Huffman Elementary School in Anchorage. Our location offers families easy access to quality education while providing a cozy haven to return to.\n\nResidents can choose from one and two-bedroom apartments equipped with thoughtful amenities like large closets, private balconies or patios, and cozy fireplaces. Plus, our promise of convenience is supported by online payment solutions and responsive on-call security. Enjoy the benefits of living in a community that values both proximity to schools and the comforts of home by opting for Chugach South.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Surrounding Huffman Elementary",
      "seo_description": "Find apartments surrounding Huffman Elementary School at Chugach South, perfect for families seeking comfort and convenience in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-alaska-anchorage",
      "search_query": "apartments near University of Alaska Anchorage",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Anchorage",
      "h2_subtitle": "Discover apartments near the University of Alaska Anchorage at Chugach South, perfect for students and professionals seeking convenience and modern comfort.",
      "page_copy": "Chugach South offers ideal living solutions for those seeking apartments near the University of Alaska Anchorage. Positioned in a serene South Anchorage neighborhood, residents can enjoy easy access to the university while residing in a peaceful community.\n\nOur one and two-bedroom apartments feature spacious closets, inviting patios or balconies, and fireplaces perfect for cozy evenings. We prioritize user-friendly amenities, including online payment and service request systems, alongside reliable on-call security. Choose Chugach South for the convenience of proximity to higher education coupled with the tranquility of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Alaska Anchorage",
      "seo_description": "Explore apartments near the University of Alaska Anchorage at Chugach South, offering convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center",
      "search_query": "apartments near Alaska Native Medical Center Anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Discover Chugach South's apartments near the Alaska Native Medical Center in Anchorage, blending convenience with comfortable living.",
      "page_copy": "For those needing apartments near Alaska Native Medical Center in Anchorage, Chugach South offers an ideal solution. Positioned conveniently yet nestled in a tranquil community environment, our location combines ease of access with peaceful living.\n\nEnjoy spacious living in our one and two-bedroom apartments, featuring amenities like large closets, personal patios or balconies, and fireplaces for added comfort. Our community also supports modern lifestyles with online payment systems and on-call security services. Experience the perfect balance of work and relaxation by choosing Chugach South as your home base near the medical center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Find comfortable living with Chugach South's apartments near the Alaska Native Medical Center in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-close-to-alaska-regional-hospital-99515",
      "search_query": "apartments close to Alaska Regional Hospital 99515",
      "category": "Hospital",
      "h1_title": "Apartments Close to Alaska Regional Hospital",
      "h2_subtitle": "Explore Chugach South's inviting apartments close to Alaska Regional Hospital, 99515, where convenience meets comfort in Anchorage.",
      "page_copy": "Chugach South offers the perfect apartments close to Alaska Regional Hospital, making it an ideal choice for healthcare professionals and patients. Situated in the charming Bayshore / Klatt neighborhood, our community provides residents with a restful retreat just minutes from the hospital.\n\nChoose from thoughtfully designed one and two-bedroom floor plans, each featuring details like expansive closets and cozy fireplaces. Enjoy your own patio or balcony, perfect for unwinding after a long day. With facilities like online payment and service requests, plus the assurance of on-call security, Chugach South ensures a hassle-free living experience near the hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Alaska Regional Hospital",
      "seo_description": "Discover comfort at Chugach South's apartments close to Alaska Regional Hospital, 99515, perfect for professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-by-alaska-va-healthcare-system",
      "search_query": "apartments by Alaska VA Healthcare System Bayshore Klatt",
      "category": "Hospital",
      "h1_title": "Apartments by Alaska VA Healthcare System",
      "h2_subtitle": "Find comfort in Chugach South's apartments by the Alaska VA Healthcare System in Bayshore Klatt, offering a serene living experience.",
      "page_copy": "If you're seeking apartments by the Alaska VA Healthcare System in Bayshore Klatt, Chugach South is your answer. Located in the peaceful South Anchorage neighborhood, our community provides easy access to the healthcare system while offering a soothing residential atmosphere.\n\nOur spacious one and two-bedroom apartments come equipped with appealing features like extensive closets, personal balconies or patios, and cozy fireplaces. Residents enjoy the ease of online payments and have peace of mind with our on-call security and courtesy patrol services. Make Chugach South your home and experience the perfect balance of convenience and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Alaska VA Healthcare System",
      "seo_description": "Explore Chugach South's tranquil apartments by the Alaska VA Healthcare System in Bayshore Klatt for convenient, comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-botanical-garden",
      "search_query": "apartments near alaska botanical garden anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Alaska Botanical Garden",
      "h2_subtitle": "Discover Chugach South's charming apartments near the Alaska Botanical Garden in Anchorage, perfect for nature lovers.",
      "page_copy": "Looking for apartments near the Alaska Botanical Garden in Anchorage? Chugach South provides an excellent choice with a picturesque setting close to this natural haven. Nestled within the Bayshore / Klatt area, our community combines accessibility with the tranquility of South Anchorage living.\n\nOur one and two-bedroom apartments boast features such as large closets, private patios or balconies, and welcoming fireplaces, creating a cozy retreat after a day at the gardens. Residents benefit from modern conveniences like online payments and on-call security, ensuring peace of mind and easy living. Experience the beauty of Anchorage's botanicals right outside your door at Chugach South.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Botanical Garden",
      "seo_description": "Find nature-inspired living at Chugach South, with apartments near Alaska Botanical Garden in Anchorage, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-close-to-south-anchorage-sports-park",
      "search_query": "apartments close to south anchorage sports park",
      "category": "Park",
      "h1_title": "Apartments Close to South Anchorage Sports Park",
      "h2_subtitle": "Chugach South's apartments provide easy access to the South Anchorage Sports Park, offering a perfect blend of recreation and comfort.",
      "page_copy": "For those seeking apartments close to South Anchorage Sports Park, Chugach South is an ideal choice. Located conveniently in the vibrant Bayshore / Klatt neighborhood, our community offers easy access to the sports park, making it perfect for outdoor enthusiasts.\n\nOur comfortable one and two-bedroom apartments feature modern amenities like expansive closets, fireplaces, and balconies or patios, allowing for a seamless indoor-outdoor lifestyle. With online payments and service requests, plus an attentive on-call security team, living here is all about ease and peace of mind. Enjoy an active lifestyle with the sports park nearby while relaxing in the comfort of Chugach South.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to South Anchorage Sports Park",
      "seo_description": "Enjoy active living at Chugach South, with apartments close to South Anchorage Sports Park, combining convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-south-anchorage-dog-park",
      "search_query": "apartments near south anchorage dog park",
      "category": "Park",
      "h1_title": "Apartments Near South Anchorage Dog Park",
      "h2_subtitle": "Find the ideal pet-friendly living at Chugach South, located near the South Anchorage Dog Park, offering comfort and convenience.",
      "page_copy": "Searching for pet-friendly apartments near the South Anchorage Dog Park? Chugach South provides a welcoming community close to this popular spot, ensuring your furry friends have a place to play and socialize. Conveniently located in the Bayshore / Klatt area, Chugach South offers a balance of pet-friendly amenities and comfortable living.\n\nOur one and two-bedroom apartments feature large closets, cozy fireplaces, and private balconies or patios, making it easy to settle in with your pet. Residents enjoy modern conveniences like online payment options and on-call security services for a stress-free living experience. Make Chugach South your home and keep your pets happy with the park just a short walk away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near South Anchorage Dog Park",
      "seo_description": "Enjoy pet-friendly living at Chugach South, with apartments near South Anchorage Dog Park, blending comfort and convenience for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-close-to-sand-lake-public-access",
      "search_query": "apartments close to sand lake public access",
      "category": "Park",
      "h1_title": "Apartments Close to Sand Lake Public Access",
      "h2_subtitle": "Explore Chugach South's proximity to Sand Lake Public Access, where tranquil living meets outdoor adventure.",
      "page_copy": "If you're searching for apartments close to Sand Lake Public Access, look no further than Chugach South. Our prime location in the Bayshore / Klatt neighborhood offers easy access to the serene waters of Sand Lake, providing a perfect setting for outdoor enthusiasts and nature lovers.\n\nChugach South features spacious one and two-bedroom apartments with cozy fireplaces, ample storage with large closets, and the comfort of private patios or balconies. Convenience is key with amenities like online payments, maintenance requests, and reliable on-call security. Experience the best of South Anchorage living with recreational opportunities just moments away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Sand Lake Public Access",
      "seo_description": "Discover lakeside living at Chugach South, with apartments close to Sand Lake Public Access, offering comfort and outdoor fun.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-kincaid-park-anchorage-municipality",
      "search_query": "apartments near kincaid park anchorage municipality",
      "category": "Park",
      "h1_title": "Apartments Near Kincaid Park Anchorage",
      "h2_subtitle": "Discover Chugach South, offering comfortable living near Kincaid Park within Anchorage Municipality, perfect for nature enthusiasts.",
      "page_copy": "For those interested in apartments near Kincaid Park within Anchorage Municipality, Chugach South offers the perfect blend of convenience and natural beauty. Our community is just a short drive from Kincaid Park, known for its extensive trails, wildlife, and outdoor activities, providing an ideal escape into the great Alaskan outdoors.\n\nOur spacious one and two-bedroom homes are designed with comfort in mind, featuring large closets, cozy fireplaces, and private patios or balconies. Residents enjoy modern conveniences like online payments and attentive on-call security, ensuring a worry-free lifestyle. Choose Chugach South and embrace a vibrant living experience with easy access to Kincaid Park's natural wonders.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kincaid Park Anchorage",
      "seo_description": "Live near Kincaid Park in Anchorage Municipality at Chugach South, offering comfortable, convenient apartments in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167187",
      "source": "generator",
      "page_item_url": "apartments-near-ted-stevens-anchorage-airport",
      "search_query": "apartments near ted stevens anchorage international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Ted Stevens Anchorage Airport",
      "h2_subtitle": "Chugach South provides convenient living near Ted Stevens Anchorage International Airport, perfect for frequent flyers and travel enthusiasts.",
      "page_copy": "Looking for apartments near Ted Stevens Anchorage International Airport? Chugach South is ideally located for those who seek convenient access to this travel hub. Our community is situated in the Bayshore / Klatt neighborhood, making it a strategic choice for frequent travelers and professionals working at the airport.\n\nChugach South offers spacious one and two-bedroom apartments featuring fireplaces, large closets, and patios or balconies. Enjoy modern conveniences such as online payments and reliable on-call security, all designed to make life easier. Experience the perfect blend of comfort and convenience by choosing Chugach South as your home base near the airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a fireplace, a couch, and large window overlooking greenery.",
        "public_id": "019e0641-2f6f-7706-809f-3189ba9923a8",
        "storage_key": "property/6767906449167187/019e0641-2f6f-7706-809f-3189ba9923a8.webp",
        "width": 1448,
        "height": 1086
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ted Stevens Anchorage Airport",
      "seo_description": "Discover convenient living at Chugach South, offering apartments near Ted Stevens Anchorage International Airport, perfect for travel-savvy residents.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309495677"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085109"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5B97XGND"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.3"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "bcd2ccc0-8a65-4d95-ad6e-3acbc8bcf64c"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Homestead"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3962d073-a754-42e2-b0b8-606d511a7217/app.js?property=3962d073-a754-42e2-b0b8-606d511a7217&propertyName=Chugach+South&channelUuid=c248ff39-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47754697591"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlFtL0NXUEVPNXlrenBNVjV4TzlkMEE9PSIsInZhbHVlIjoiYk5NNE5QdGZuTHlFRHFLNEk2RVVrdz09IiwibWFjIjoiMzNkMTZkMjhiMTIyYTcwNTI4OWM0YTU3YTQ2ZGE0OWI4NTQ3ZWI3YzQxMGU0ZDNiMWMzN2IyZmUzYzUwNDA2MCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309495677",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085109",
  "custom_google_gtm_id": "GTM-5B97XGND",
  "custom_rollout_phase": "Phase 7.3",
  "custom_rentgrata_token": "bcd2ccc0-8a65-4d95-ad6e-3acbc8bcf64c",
  "custom_vibesites_theme": "Homestead",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3962d073-a754-42e2-b0b8-606d511a7217/app.js?property=3962d073-a754-42e2-b0b8-606d511a7217&propertyName=Chugach+South&channelUuid=c248ff39-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47754697591",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlFtL0NXUEVPNXlrenBNVjV4TzlkMEE9PSIsInZhbHVlIjoiYk5NNE5QdGZuTHlFRHFLNEk2RVVrdz09IiwibWFjIjoiMzNkMTZkMjhiMTIyYTcwNTI4OWM0YTU3YTQ2ZGE0OWI4NTQ3ZWI3YzQxMGU0ZDNiMWMzN2IyZmUzYzUwNDA2MCJ9",
  "custom_audioeye_site_id": "efacb284-3dec-49be-b289-ad69e055e8a6",
  "custom_audioeye_site_hash": "8138e6c250128a4fbdc2664a6aac1199"
};

export const generatedAt = '2026-10-29T23:16:17.183Z';
